{
  "__schema": {
    "types": [
      {
        "kind": "UNION",
        "name": "Admin",
        "possibleTypes": [
          {
            "name": "JiraUser"
          },
          {
            "name": "JiraUserGroup"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "AllActivityFeedItemUnion",
        "possibleTypes": [
          {
            "name": "HistoryItem"
          },
          {
            "name": "CommentItem"
          },
          {
            "name": "WorklogItem"
          },
          {
            "name": "IncidentItem"
          },
          {
            "name": "ApprovalItem"
          },
          {
            "name": "HiddenCommentItem"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ApprovalActivityValueUnion",
        "possibleTypes": [
          {
            "name": "ApprovalCreated"
          },
          {
            "name": "ApproverDecision"
          },
          {
            "name": "ApprovalCompleted"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "AutoManagedSprintJobError",
        "possibleTypes": [
          {
            "name": "AutoManagedSprintGenericError"
          },
          {
            "name": "AutoManagedSprintOpenSubtasksError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BaseIssueField",
        "possibleTypes": [
          {
            "name": "AffectedServicesField"
          },
          {
            "name": "AttachmentsField"
          },
          {
            "name": "CascadingSelectCustomField"
          },
          {
            "name": "CheckBoxesCustomField"
          },
          {
            "name": "ChildIssuesField"
          },
          {
            "name": "CmdbField"
          },
          {
            "name": "ColorField"
          },
          {
            "name": "CommentSummaryField"
          },
          {
            "name": "DateField"
          },
          {
            "name": "DatePickerCustomField"
          },
          {
            "name": "DateTimeCustomField"
          },
          {
            "name": "DateTimeField"
          },
          {
            "name": "EpicColorField"
          },
          {
            "name": "EpicLinkField"
          },
          {
            "name": "EpicNameField"
          },
          {
            "name": "EpicStatusField"
          },
          {
            "name": "FlaggedCustomField"
          },
          {
            "name": "FloatCustomField"
          },
          {
            "name": "GlancesField"
          },
          {
            "name": "GroupPickerCustomField"
          },
          {
            "name": "IssueKeyField"
          },
          {
            "name": "IssueLinksField"
          },
          {
            "name": "IssueTypeField"
          },
          {
            "name": "IssuesInEpicField"
          },
          {
            "name": "JWMCategoryCustomField"
          },
          {
            "name": "LabelsCustomField"
          },
          {
            "name": "LabelsField"
          },
          {
            "name": "MultiGroupPickerCustomField"
          },
          {
            "name": "MultiSelectCustomField"
          },
          {
            "name": "MultiUserPickerCustomField"
          },
          {
            "name": "MultiVersionCustomField"
          },
          {
            "name": "ParentField"
          },
          {
            "name": "PeopleCustomField"
          },
          {
            "name": "PriorityField"
          },
          {
            "name": "ProjectComponentsField"
          },
          {
            "name": "ProjectCustomField"
          },
          {
            "name": "ProjectField"
          },
          {
            "name": "RadioButtonsCustomField"
          },
          {
            "name": "ResolutionField"
          },
          {
            "name": "SLACustomField"
          },
          {
            "name": "SecurityLevelField"
          },
          {
            "name": "SelectCustomField"
          },
          {
            "name": "SeverityField"
          },
          {
            "name": "SprintCustomField"
          },
          {
            "name": "StatusField"
          },
          {
            "name": "StoryPointsField"
          },
          {
            "name": "SubtasksField"
          },
          {
            "name": "TechLeadField"
          },
          {
            "name": "TextAreaCustomField"
          },
          {
            "name": "TextField"
          },
          {
            "name": "TextFieldCustomField"
          },
          {
            "name": "TimeEstimateField"
          },
          {
            "name": "TimeOriginalEstimateField"
          },
          {
            "name": "TimeSpentField"
          },
          {
            "name": "TimeTrackingField"
          },
          {
            "name": "UrlCustomField"
          },
          {
            "name": "UserField"
          },
          {
            "name": "UserPickerCustomField"
          },
          {
            "name": "VersionCustomField"
          },
          {
            "name": "VersionsField"
          },
          {
            "name": "WatchersField"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BaseSprint",
        "possibleTypes": [
          {
            "name": "SoftwareSprint"
          },
          {
            "name": "SprintWithStatistics"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "BoardFeatureView",
        "possibleTypes": [
          {
            "name": "BasicBoardFeatureView"
          },
          {
            "name": "EstimationBoardFeatureView"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ConfluencePageUnion",
        "possibleTypes": [
          {
            "name": "ConfluencePage"
          },
          {
            "name": "FailedRemoteLink"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "GQLCategorizedField",
        "possibleTypes": [
          {
            "name": "GQLSortableField"
          },
          {
            "name": "GQLSearchableField"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "GQLField",
        "possibleTypes": [
          {
            "name": "GQLSearchableField"
          },
          {
            "name": "GQLSortableField"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "GadgetParameters",
        "possibleTypes": [
          {
            "name": "VotedGadgetParameters"
          },
          {
            "name": "AssignedToMeGadgetParameters"
          },
          {
            "name": "WatchedGadgetParameters"
          },
          {
            "name": "InProgressGadgetParameters"
          },
          {
            "name": "FilterResultsGadgetParameters"
          },
          {
            "name": "TwoDimensionalStatisticsParameters"
          },
          {
            "name": "PieChartParameters"
          },
          {
            "name": "IssueStatisticsParameters"
          },
          {
            "name": "WorkloadPieChartParameters"
          },
          {
            "name": "ActivityStreamGadgetParameters"
          },
          {
            "name": "CreatedVsResolvedGadgetParameters"
          },
          {
            "name": "SprintGadgetParameters"
          },
          {
            "name": "ProjectsGadgetParameters"
          },
          {
            "name": "ConnectGadgetParameters"
          },
          {
            "name": "NotConfiguredGadgetParameters"
          },
          {
            "name": "UnsupportedGadgetParameters"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "GroupByFieldUnion",
        "possibleTypes": [
          {
            "name": "PriorityField"
          },
          {
            "name": "StatusField"
          },
          {
            "name": "UserField"
          },
          {
            "name": "LabelsField"
          },
          {
            "name": "SelectCustomField"
          },
          {
            "name": "JWMCategoryCustomField"
          },
          {
            "name": "IssueTypeField"
          },
          {
            "name": "StoryPointsField"
          },
          {
            "name": "SprintCustomField"
          },
          {
            "name": "FloatCustomField"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "GroupSectionItem",
        "possibleTypes": [
          {
            "name": "FieldSectionItem"
          },
          {
            "name": "EcosystemSectionItem"
          },
          {
            "name": "ForgeSectionItem"
          },
          {
            "name": "PanelSectionItem"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "HasMercuryProjectFields",
        "possibleTypes": [
          {
            "name": "JiraIssue"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "HasPageInfo",
        "possibleTypes": [
          {
            "name": "JiraAccessActorConnection"
          },
          {
            "name": "JiraActorConnection"
          },
          {
            "name": "JiraAssignableUsersConnection"
          },
          {
            "name": "JiraBulkEditFieldsConnection"
          },
          {
            "name": "JiraBulkMergeValidatedIssuesConnection"
          },
          {
            "name": "JiraFieldSchemesConnection"
          },
          {
            "name": "JiraFormattingRuleConnection"
          },
          {
            "name": "JiraNavigationItemConnection"
          },
          {
            "name": "JiraNavigationItemTypeConnection"
          },
          {
            "name": "JiraNotificationProjectPreferenceConnection"
          },
          {
            "name": "JiraProjectConnection"
          },
          {
            "name": "JiraProjectPolicyAssociationConnection"
          },
          {
            "name": "JiraProjectPolicyConnection"
          },
          {
            "name": "JiraProjectPolicyRuleConnection"
          },
          {
            "name": "JiraProjectPolicyRuleViolationConnection"
          },
          {
            "name": "JiraStatusConnection"
          },
          {
            "name": "JiraUserBroadcastMessageConnection"
          },
          {
            "name": "JiraWorkManagementSavedViewTypeConnection"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "HasTotal",
        "possibleTypes": [
          {
            "name": "JiraAccessActorConnection"
          },
          {
            "name": "JiraAssignableUsersConnection"
          },
          {
            "name": "JiraBulkEditFieldsConnection"
          },
          {
            "name": "JiraBulkMergeValidatedIssuesConnection"
          },
          {
            "name": "JiraFieldSchemesConnection"
          },
          {
            "name": "JiraNotificationProjectPreferenceConnection"
          },
          {
            "name": "JiraProjectConnection"
          },
          {
            "name": "JiraProjectPolicyAssociationConnection"
          },
          {
            "name": "JiraProjectPolicyConnection"
          },
          {
            "name": "JiraProjectPolicyRuleConnection"
          },
          {
            "name": "JiraProjectPolicyRuleViolationConnection"
          },
          {
            "name": "JiraUserBroadcastMessageConnection"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "HistoryValue",
        "possibleTypes": [
          {
            "name": "AssigneeFieldValue"
          },
          {
            "name": "PriorityFieldValue"
          },
          {
            "name": "StatusFieldValue"
          },
          {
            "name": "WorkLogFieldValue"
          },
          {
            "name": "RespondersFieldValue"
          },
          {
            "name": "GenericFieldValue"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "IncidentActivityValueUnion",
        "possibleTypes": [
          {
            "name": "ResponderAlertAssignedValue"
          },
          {
            "name": "AlertValue"
          },
          {
            "name": "ResponderAlertPriorityChangedValue"
          },
          {
            "name": "IccSessionValue"
          },
          {
            "name": "IccSessionInvitationValue"
          },
          {
            "name": "StakeholderUpdatedValue"
          },
          {
            "name": "IncidentStakeholderActionValue"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "IssueFieldUnion",
        "possibleTypes": [
          {
            "name": "PriorityField"
          },
          {
            "name": "StatusField"
          },
          {
            "name": "IssueTypeField"
          },
          {
            "name": "ProjectComponentsField"
          },
          {
            "name": "LabelsField"
          },
          {
            "name": "WatchersField"
          },
          {
            "name": "UserField"
          },
          {
            "name": "TextField"
          },
          {
            "name": "VersionsField"
          },
          {
            "name": "DateField"
          },
          {
            "name": "DateTimeField"
          },
          {
            "name": "IssueKeyField"
          },
          {
            "name": "ProjectField"
          },
          {
            "name": "ResolutionField"
          },
          {
            "name": "TimeTrackingField"
          },
          {
            "name": "TimeOriginalEstimateField"
          },
          {
            "name": "TimeEstimateField"
          },
          {
            "name": "TimeSpentField"
          },
          {
            "name": "StoryPointsField"
          },
          {
            "name": "EpicLinkField"
          },
          {
            "name": "EpicNameField"
          },
          {
            "name": "ColorField"
          },
          {
            "name": "EpicColorField"
          },
          {
            "name": "SprintCustomField"
          },
          {
            "name": "SelectCustomField"
          },
          {
            "name": "FlaggedCustomField"
          },
          {
            "name": "UserPickerCustomField"
          },
          {
            "name": "TextAreaCustomField"
          },
          {
            "name": "FloatCustomField"
          },
          {
            "name": "DatePickerCustomField"
          },
          {
            "name": "TextFieldCustomField"
          },
          {
            "name": "MultiSelectCustomField"
          },
          {
            "name": "LabelsCustomField"
          },
          {
            "name": "MultiUserPickerCustomField"
          },
          {
            "name": "PeopleCustomField"
          },
          {
            "name": "UrlCustomField"
          },
          {
            "name": "VersionCustomField"
          },
          {
            "name": "GroupPickerCustomField"
          },
          {
            "name": "MultiVersionCustomField"
          },
          {
            "name": "MultiGroupPickerCustomField"
          },
          {
            "name": "CheckBoxesCustomField"
          },
          {
            "name": "RadioButtonsCustomField"
          },
          {
            "name": "DateTimeCustomField"
          },
          {
            "name": "SeverityField"
          },
          {
            "name": "AffectedServicesField"
          },
          {
            "name": "TechLeadField"
          },
          {
            "name": "AttachmentsField"
          },
          {
            "name": "GlancesField"
          },
          {
            "name": "SecurityLevelField"
          },
          {
            "name": "IssueLinksField"
          },
          {
            "name": "IssuesInEpicField"
          },
          {
            "name": "SubtasksField"
          },
          {
            "name": "ChildIssuesField"
          },
          {
            "name": "CascadingSelectCustomField"
          },
          {
            "name": "CmdbField"
          },
          {
            "name": "SLACustomField"
          },
          {
            "name": "ProjectCustomField"
          },
          {
            "name": "EpicStatusField"
          },
          {
            "name": "ParentField"
          },
          {
            "name": "JWMCategoryCustomField"
          },
          {
            "name": "CommentSummaryField"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "IssueSections",
        "possibleTypes": [
          {
            "name": "PrimarySecondaryContextSections"
          },
          {
            "name": "JsdSections"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IssueTableParameters",
        "possibleTypes": [
          {
            "name": "AssignedToMeGadgetParameters"
          },
          {
            "name": "FilterResultsGadgetParameters"
          },
          {
            "name": "InProgressGadgetParameters"
          },
          {
            "name": "VotedGadgetParameters"
          },
          {
            "name": "WatchedGadgetParameters"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraAccessActor",
        "possibleTypes": [
          {
            "name": "JiraAccessUserActor"
          },
          {
            "name": "JiraAccessGroupActor"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraActiveBackgroundDetailsResult",
        "possibleTypes": [
          {
            "name": "JiraColorBackground"
          },
          {
            "name": "JiraGradientBackground"
          },
          {
            "name": "JiraMediaBackground"
          },
          {
            "name": "JiraAttachmentBackground"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraActor",
        "possibleTypes": [
          {
            "name": "JiraAgenticUser"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraAggregatedDate",
        "possibleTypes": [
          {
            "name": "JiraDatePickerField"
          },
          {
            "name": "JiraDateTimePickerField"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraAllActivityFeedItemUnion",
        "possibleTypes": [
          {
            "name": "JiraHistoryItem"
          },
          {
            "name": "JiraCommentItem"
          },
          {
            "name": "JiraWorklogItem"
          },
          {
            "name": "JiraApprovalItem"
          },
          {
            "name": "JiraHiddenCommentItem"
          },
          {
            "name": "JiraIncidentItem"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraAppNavigationConfig",
        "possibleTypes": [
          {
            "name": "JiraAppNavigationItem"
          },
          {
            "name": "JiraAppNavigationItemNestedLink"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraApprovalActivityValueUnion",
        "possibleTypes": [
          {
            "name": "JiraApprovalCreated"
          },
          {
            "name": "JiraApproverDecision"
          },
          {
            "name": "JiraApprovalCompleted"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraAtlassianIntelligenceAction",
        "possibleTypes": [
          {
            "name": "JiraAccessAtlassianIntelligenceFeature"
          },
          {
            "name": "JiraEnableAtlassianIntelligenceDeepLink"
          },
          {
            "name": "JiraContactOrgAdminToEnableAtlassianIntelligence"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraAttachment",
        "possibleTypes": [
          {
            "name": "JiraPlatformAttachment"
          },
          {
            "name": "JiraServiceManagementAttachment"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraAutoManagedSprintJobError",
        "possibleTypes": [
          {
            "name": "JiraAutoManagedSprintGenericError"
          },
          {
            "name": "JiraAutoManagedSprintOpenSubtasksError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraBackground",
        "possibleTypes": [
          {
            "name": "JiraAttachmentBackground"
          },
          {
            "name": "JiraColorBackground"
          },
          {
            "name": "JiraGradientBackground"
          },
          {
            "name": "JiraMediaBackground"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraBackgroundUploadTokenResult",
        "possibleTypes": [
          {
            "name": "JiraBackgroundUploadToken"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraBacklogViewCardList",
        "possibleTypes": [
          {
            "name": "JiraBacklogViewColumnCardList"
          },
          {
            "name": "JiraBacklogViewSprintCardList"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraBaseNextActionsEntity",
        "possibleTypes": [
          {
            "name": "JiraImproveDescriptionSuggestion"
          },
          {
            "name": "JiraRelatedLinkSuggestions"
          },
          {
            "name": "JiraSDLCSuggestions"
          },
          {
            "name": "JiraSimilarWorkItemSuggestions"
          },
          {
            "name": "JiraWorkBreakdownSuggestions"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraBaseTimelineView",
        "possibleTypes": [
          {
            "name": "JiraGroupedTimelineView"
          },
          {
            "name": "JiraTimelineView"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraBoardResult",
        "possibleTypes": [
          {
            "name": "JiraBoard"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraBoardViewCardOption",
        "possibleTypes": [
          {
            "name": "JiraBoardViewFieldCardOption"
          },
          {
            "name": "JiraBoardViewSyntheticFieldCardOption"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraBoardViewCellContainer",
        "possibleTypes": [
          {
            "name": "JiraBoardViewColumnLayout"
          },
          {
            "name": "JiraBoardViewFieldSwimlane"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraBoardViewColumn",
        "possibleTypes": [
          {
            "name": "JiraBoardViewAssigneeColumn"
          },
          {
            "name": "JiraBoardViewCategoryColumn"
          },
          {
            "name": "JiraBoardViewPriorityColumn"
          },
          {
            "name": "JiraBoardViewStatusColumn"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraBoardViewFieldSwimlaneValue",
        "possibleTypes": [
          {
            "name": "JiraBoardViewFieldSwimlaneAgent"
          },
          {
            "name": "JiraBoardViewFieldSwimlaneUser"
          },
          {
            "name": "JiraIssue"
          },
          {
            "name": "JiraOption"
          },
          {
            "name": "JiraPriority"
          },
          {
            "name": "JiraTownsquareProject"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraBoardViewLayout",
        "possibleTypes": [
          {
            "name": "JiraBoardViewColumnLayout"
          },
          {
            "name": "JiraBoardViewSwimlaneLayout"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraBoardViewSwimlane",
        "possibleTypes": [
          {
            "name": "JiraBoardViewFieldSwimlane"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraBulkMergeValidationResult",
        "possibleTypes": [
          {
            "name": "JiraBulkMergeValidationResponse"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraCFOAnalyticsResult",
        "possibleTypes": [
          {
            "name": "JiraCFOBoardPerformanceAnalyticsResult"
          },
          {
            "name": "JiraCFODefaultAnalyticsResult"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraCFODataRow",
        "possibleTypes": [
          {
            "name": "JiraCFOBoardPerformanceDataRow"
          },
          {
            "name": "JiraCFODefaultDataRow"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraCFOMetricSummary",
        "possibleTypes": [
          {
            "name": "JiraCFOBoardPerformanceMetricSummary"
          },
          {
            "name": "JiraCFODefaultMetricSummary"
          },
          {
            "name": "JiraCFOLoadTimeMetricSummary"
          },
          {
            "name": "JiraCFOUserSetupMetricSummary"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraChildIssues",
        "possibleTypes": [
          {
            "name": "JiraChildIssuesWithinLimit"
          },
          {
            "name": "JiraChildIssuesExceedingLimit"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraComment",
        "possibleTypes": [
          {
            "name": "JiraPlatformComment"
          },
          {
            "name": "JiraServiceManagementComment"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraCommentVisibility",
        "possibleTypes": [
          {
            "name": "JiraRoleVisibility"
          },
          {
            "name": "JiraGroupVisibility"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraConfluencePageContent",
        "possibleTypes": [
          {
            "name": "JiraConfluencePageContentDetails"
          },
          {
            "name": "JiraConfluencePageContentError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraConsolidatedResource",
        "possibleTypes": [
          {
            "name": "JiraAttachmentResource"
          },
          {
            "name": "JiraConfluenceLinkResource"
          },
          {
            "name": "JiraRemoteLinkResource"
          },
          {
            "name": "JiraWhiteboardResource"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraConsolidatedResourceDetails",
        "possibleTypes": [
          {
            "name": "JiraAttachmentDetails"
          },
          {
            "name": "JiraConfluenceLinkDetails"
          },
          {
            "name": "JiraRemoteLinkDetails"
          },
          {
            "name": "JiraWhiteboardDetails"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraContainerNavigationResult",
        "possibleTypes": [
          {
            "name": "JiraContainerNavigation"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraDateLikeField",
        "possibleTypes": [
          {
            "name": "JiraDateFormulaField"
          },
          {
            "name": "JiraDatePickerField"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraDefaultUnsplashImagesPageResult",
        "possibleTypes": [
          {
            "name": "JiraDefaultUnsplashImagesPage"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraDevOpsProvider",
        "possibleTypes": [
          {
            "name": "JiraBitbucketDevOpsProvider"
          },
          {
            "name": "JiraClassicConnectDevOpsProvider"
          },
          {
            "name": "JiraOAuthDevOpsProvider"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraEmptyConnectionReason",
        "possibleTypes": [
          {
            "name": "JiraDefaultEmptyConnectionReason"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraEntityProperty",
        "possibleTypes": [
          {
            "name": "JiraEntityPropertyBoolean"
          },
          {
            "name": "JiraEntityPropertyInt"
          },
          {
            "name": "JiraEntityPropertyJSON"
          },
          {
            "name": "JiraEntityPropertyLastDismissedAnnouncementBanner"
          },
          {
            "name": "JiraEntityPropertyString"
          },
          {
            "name": "JiraNavigationUIStateUserProperty"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraFavourite",
        "possibleTypes": [
          {
            "name": "JiraProject"
          },
          {
            "name": "JiraSystemFilter"
          },
          {
            "name": "JiraCustomFilter"
          },
          {
            "name": "JiraDashboard"
          },
          {
            "name": "JiraPlan"
          },
          {
            "name": "JiraBoard"
          },
          {
            "name": "JiraServiceManagementQueue"
          },
          {
            "name": "JiraProductDiscoveryCollection"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraFieldContextualData",
        "possibleTypes": [
          {
            "name": "JiraFieldContextualDataTeamsFilter"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraFieldError",
        "possibleTypes": []
      },
      {
        "kind": "UNION",
        "name": "JiraFieldFormatConfig",
        "possibleTypes": [
          {
            "name": "JiraNumberFieldFormatConfig"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraFieldSetViewResult",
        "possibleTypes": [
          {
            "name": "JiraFieldSetView"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraFieldSetsViewMetadata",
        "possibleTypes": [
          {
            "name": "JiraDetailedView"
          },
          {
            "name": "JiraFieldSetView"
          },
          {
            "name": "JiraGroupedListView"
          },
          {
            "name": "JiraGroupedTimelineView"
          },
          {
            "name": "JiraListView"
          },
          {
            "name": "JiraTimelineView"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraFilter",
        "possibleTypes": [
          {
            "name": "JiraCustomFilter"
          },
          {
            "name": "JiraSystemFilter"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraFlatOption",
        "possibleTypes": [
          {
            "name": "JiraParentOption"
          },
          {
            "name": "JiraOption"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraFormFieldCondition",
        "possibleTypes": [
          {
            "name": "JiraFormSelectCondition"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraFormattingExpression",
        "possibleTypes": [
          {
            "name": "JiraFormattingSingleValueOperand"
          },
          {
            "name": "JiraFormattingTwoValueOperand"
          },
          {
            "name": "JiraFormattingMultipleValueOperand"
          },
          {
            "name": "JiraFormattingNoValueOperand"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraFormulaFieldValue",
        "possibleTypes": [
          {
            "name": "JiraFormulaFieldTextValue"
          },
          {
            "name": "JiraFormulaFieldNumberValue"
          },
          {
            "name": "JiraFormulaFieldDateValue"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraGlobalPermissionGrantsResult",
        "possibleTypes": [
          {
            "name": "JiraGlobalPermissionGrantsList"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraGrantTypeValue",
        "possibleTypes": [
          {
            "name": "JiraDefaultGrantTypeValue"
          },
          {
            "name": "JiraUserGrantTypeValue"
          },
          {
            "name": "JiraProjectRoleGrantTypeValue"
          },
          {
            "name": "JiraGroupGrantTypeValue"
          },
          {
            "name": "JiraIssueFieldGrantTypeValue"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraGroupLayoutItem",
        "possibleTypes": [
          {
            "name": "JiraFieldLayoutItem"
          },
          {
            "name": "JiraEcosystemLayoutItem"
          },
          {
            "name": "JiraForgeLayoutItem"
          },
          {
            "name": "JiraPanelLayoutItem"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraHasMultipleSelectedValues",
        "possibleTypes": [
          {
            "name": "JiraAffectedServicesField"
          },
          {
            "name": "JiraConnectMultipleSelectField"
          },
          {
            "name": "JiraMultipleSelectField"
          },
          {
            "name": "JiraMultipleVersionPickerField"
          },
          {
            "name": "JiraServiceManagementOrganizationField"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraHasSelectableValueOptions",
        "possibleTypes": [
          {
            "name": "JiraAffectedServicesField"
          },
          {
            "name": "JiraCascadingSelectField"
          },
          {
            "name": "JiraConnectMultipleSelectField"
          },
          {
            "name": "JiraConnectSingleSelectField"
          },
          {
            "name": "JiraMultipleSelectField"
          },
          {
            "name": "JiraMultipleVersionPickerField"
          },
          {
            "name": "JiraParentOption"
          },
          {
            "name": "JiraServiceManagementOrganizationField"
          },
          {
            "name": "JiraSingleSelectField"
          },
          {
            "name": "JiraSingleVersionPickerField"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraHasSingleSelectedValue",
        "possibleTypes": [
          {
            "name": "JiraConnectSingleSelectField"
          },
          {
            "name": "JiraSingleSelectField"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraHistoryValue",
        "possibleTypes": [
          {
            "name": "JiraHistoryAssigneeFieldValue"
          },
          {
            "name": "JiraHistoryPriorityFieldValue"
          },
          {
            "name": "JiraHistoryStatusFieldValue"
          },
          {
            "name": "JiraHistoryWorkLogFieldValue"
          },
          {
            "name": "JiraHistoryRespondersFieldValue"
          },
          {
            "name": "JiraHistoryGenericFieldValue"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIncidentActivityValueUnion",
        "possibleTypes": [
          {
            "name": "JiraResponderAlertAssignedValue"
          },
          {
            "name": "JiraAlertValue"
          },
          {
            "name": "JiraResponderAlertPriorityChangedValue"
          },
          {
            "name": "JiraStakeholderUpdatedValue"
          },
          {
            "name": "JiraIncidentStakeholderActionValue"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueAISummaryResult",
        "possibleTypes": [
          {
            "name": "JiraIssueAISummary"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraIssueCommandPaletteAction",
        "possibleTypes": [
          {
            "name": "JiraIssueCommandPaletteUpdateFieldAction"
          },
          {
            "name": "JiraIssueGenericCommandPaletteAction"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueCommandPaletteActionConnectionResult",
        "possibleTypes": [
          {
            "name": "JiraIssueCommandPaletteActionConnection"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueCreateAdditionalServicesResult",
        "possibleTypes": [
          {
            "name": "JiraIssueCreateAdditionalServices"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueCreateFieldsResult",
        "possibleTypes": [
          {
            "name": "JiraIssueCreateFields"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueCreateLayoutResult",
        "possibleTypes": [
          {
            "name": "JiraIssueCreateLayout"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraIssueCreateService",
        "possibleTypes": [
          {
            "name": "JiraIssueCreateProformaConfiguration"
          },
          {
            "name": "JiraIssueCreateWatchersConfiguration"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueError",
        "possibleTypes": [
          {
            "name": "JiraRemoteLinkedIssueError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueExportEvent",
        "possibleTypes": [
          {
            "name": "JiraIssueExportTaskSubmitted"
          },
          {
            "name": "JiraIssueExportTaskProgress"
          },
          {
            "name": "JiraIssueExportTaskCompleted"
          },
          {
            "name": "JiraIssueExportTaskTerminated"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraIssueField",
        "possibleTypes": [
          {
            "name": "CalendarIssueField"
          },
          {
            "name": "GenericIssueField"
          },
          {
            "name": "JWMCategoryField"
          },
          {
            "name": "JiraAffectedServicesField"
          },
          {
            "name": "JiraAgentSessionsField"
          },
          {
            "name": "JiraAggregatedStatusField"
          },
          {
            "name": "JiraAggregatedTimelineField"
          },
          {
            "name": "JiraAssetField"
          },
          {
            "name": "JiraAtlasProjectField"
          },
          {
            "name": "JiraAtlassianTeamField"
          },
          {
            "name": "JiraAttachmentsField"
          },
          {
            "name": "JiraBoardCardCoverMediaField"
          },
          {
            "name": "JiraBooleanField"
          },
          {
            "name": "JiraCMDBField"
          },
          {
            "name": "JiraCascadingSelectField"
          },
          {
            "name": "JiraCheckboxesField"
          },
          {
            "name": "JiraColorField"
          },
          {
            "name": "JiraCommentSummaryField"
          },
          {
            "name": "JiraComponentsField"
          },
          {
            "name": "JiraConfluenceRemoteIssueLinksField"
          },
          {
            "name": "JiraConnectDateTimeField"
          },
          {
            "name": "JiraConnectMultipleSelectField"
          },
          {
            "name": "JiraConnectNumberField"
          },
          {
            "name": "JiraConnectReadOnlyField"
          },
          {
            "name": "JiraConnectRichTextField"
          },
          {
            "name": "JiraConnectSingleSelectField"
          },
          {
            "name": "JiraConnectTextField"
          },
          {
            "name": "JiraCustomerServiceOrganizationField"
          },
          {
            "name": "JiraDataClassificationField"
          },
          {
            "name": "JiraDateFormulaField"
          },
          {
            "name": "JiraDatePickerField"
          },
          {
            "name": "JiraDateRangeField"
          },
          {
            "name": "JiraDateTimePickerField"
          },
          {
            "name": "JiraDevSummaryField"
          },
          {
            "name": "JiraDurationField"
          },
          {
            "name": "JiraEpicLinkField"
          },
          {
            "name": "JiraFallbackField"
          },
          {
            "name": "JiraFlagField"
          },
          {
            "name": "JiraForgeDateField"
          },
          {
            "name": "JiraForgeDatetimeField"
          },
          {
            "name": "JiraForgeGroupField"
          },
          {
            "name": "JiraForgeGroupsField"
          },
          {
            "name": "JiraForgeNumberField"
          },
          {
            "name": "JiraForgeObjectField"
          },
          {
            "name": "JiraForgeStringField"
          },
          {
            "name": "JiraForgeStringsField"
          },
          {
            "name": "JiraForgeUserField"
          },
          {
            "name": "JiraForgeUsersField"
          },
          {
            "name": "JiraGoalsField"
          },
          {
            "name": "JiraIssueCreatedProformaFormsField"
          },
          {
            "name": "JiraIssueLinkField"
          },
          {
            "name": "JiraIssueLinkRelationshipTypeField"
          },
          {
            "name": "JiraIssueRestrictionField"
          },
          {
            "name": "JiraIssueTypeField"
          },
          {
            "name": "JiraLabelsField"
          },
          {
            "name": "JiraMultipleGroupPickerField"
          },
          {
            "name": "JiraMultipleSelectField"
          },
          {
            "name": "JiraMultipleSelectUserPickerField"
          },
          {
            "name": "JiraMultipleVersionPickerField"
          },
          {
            "name": "JiraNumberField"
          },
          {
            "name": "JiraNumberFormulaField"
          },
          {
            "name": "JiraOriginalTimeEstimateField"
          },
          {
            "name": "JiraParentIssueField"
          },
          {
            "name": "JiraPeopleField"
          },
          {
            "name": "JiraPriorityField"
          },
          {
            "name": "JiraProformaFormsField"
          },
          {
            "name": "JiraProjectField"
          },
          {
            "name": "JiraRadioSelectField"
          },
          {
            "name": "JiraRemainingTimeEstimateField"
          },
          {
            "name": "JiraRequestTypeField"
          },
          {
            "name": "JiraResolutionField"
          },
          {
            "name": "JiraRichTextField"
          },
          {
            "name": "JiraSecurityLevelField"
          },
          {
            "name": "JiraServiceManagementApprovalField"
          },
          {
            "name": "JiraServiceManagementChannelSourceField"
          },
          {
            "name": "JiraServiceManagementDateTimeField"
          },
          {
            "name": "JiraServiceManagementEntitlementField"
          },
          {
            "name": "JiraServiceManagementIncidentLinkingField"
          },
          {
            "name": "JiraServiceManagementMajorIncidentField"
          },
          {
            "name": "JiraServiceManagementMultipleSelectUserPickerField"
          },
          {
            "name": "JiraServiceManagementOrganizationField"
          },
          {
            "name": "JiraServiceManagementPeopleField"
          },
          {
            "name": "JiraServiceManagementRequestFeedbackField"
          },
          {
            "name": "JiraServiceManagementRequestLanguageField"
          },
          {
            "name": "JiraServiceManagementRequestTypeField"
          },
          {
            "name": "JiraServiceManagementRespondersField"
          },
          {
            "name": "JiraServiceManagementSentimentField"
          },
          {
            "name": "JiraServiceManagementSlaField"
          },
          {
            "name": "JiraSingleGroupPickerField"
          },
          {
            "name": "JiraSingleLineTextField"
          },
          {
            "name": "JiraSingleSelectField"
          },
          {
            "name": "JiraSingleSelectUserPickerField"
          },
          {
            "name": "JiraSingleVersionPickerField"
          },
          {
            "name": "JiraSprintField"
          },
          {
            "name": "JiraStatusCategoryField"
          },
          {
            "name": "JiraStatusField"
          },
          {
            "name": "JiraSubtaskSummaryField"
          },
          {
            "name": "JiraSubtasksField"
          },
          {
            "name": "JiraTeamField"
          },
          {
            "name": "JiraTeamViewField"
          },
          {
            "name": "JiraTextFormulaField"
          },
          {
            "name": "JiraTimeTrackingField"
          },
          {
            "name": "JiraTimelineField"
          },
          {
            "name": "JiraTownsquareProjectField"
          },
          {
            "name": "JiraUrlField"
          },
          {
            "name": "JiraVotesField"
          },
          {
            "name": "JiraWatchesField"
          },
          {
            "name": "JiraWorkCategoryField"
          },
          {
            "name": "JiraWorkLogField"
          },
          {
            "name": "JsmMultipleSelectUserPickerField"
          },
          {
            "name": "JsmOrganizationField"
          },
          {
            "name": "JsmPeopleField"
          },
          {
            "name": "JsmRequestTypeField"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraIssueFieldConfiguration",
        "possibleTypes": [
          {
            "name": "GenericIssueField"
          },
          {
            "name": "JWMCategoryField"
          },
          {
            "name": "JiraAffectedServicesField"
          },
          {
            "name": "JiraAgentSessionsField"
          },
          {
            "name": "JiraAssetField"
          },
          {
            "name": "JiraAtlasProjectField"
          },
          {
            "name": "JiraAtlassianTeamField"
          },
          {
            "name": "JiraAttachmentsField"
          },
          {
            "name": "JiraBooleanField"
          },
          {
            "name": "JiraCMDBField"
          },
          {
            "name": "JiraCascadingSelectField"
          },
          {
            "name": "JiraCheckboxesField"
          },
          {
            "name": "JiraColorField"
          },
          {
            "name": "JiraCommentSummaryField"
          },
          {
            "name": "JiraComponentsField"
          },
          {
            "name": "JiraConfluenceRemoteIssueLinksField"
          },
          {
            "name": "JiraConnectDateTimeField"
          },
          {
            "name": "JiraConnectMultipleSelectField"
          },
          {
            "name": "JiraConnectNumberField"
          },
          {
            "name": "JiraConnectReadOnlyField"
          },
          {
            "name": "JiraConnectRichTextField"
          },
          {
            "name": "JiraConnectSingleSelectField"
          },
          {
            "name": "JiraConnectTextField"
          },
          {
            "name": "JiraCustomerServiceOrganizationField"
          },
          {
            "name": "JiraDataClassificationField"
          },
          {
            "name": "JiraDateFormulaField"
          },
          {
            "name": "JiraDatePickerField"
          },
          {
            "name": "JiraDateRangeField"
          },
          {
            "name": "JiraDateTimePickerField"
          },
          {
            "name": "JiraDurationField"
          },
          {
            "name": "JiraEpicLinkField"
          },
          {
            "name": "JiraFallbackField"
          },
          {
            "name": "JiraFlagField"
          },
          {
            "name": "JiraForgeDateField"
          },
          {
            "name": "JiraForgeDatetimeField"
          },
          {
            "name": "JiraForgeGroupField"
          },
          {
            "name": "JiraForgeGroupsField"
          },
          {
            "name": "JiraForgeNumberField"
          },
          {
            "name": "JiraForgeObjectField"
          },
          {
            "name": "JiraForgeStringField"
          },
          {
            "name": "JiraForgeStringsField"
          },
          {
            "name": "JiraForgeUserField"
          },
          {
            "name": "JiraForgeUsersField"
          },
          {
            "name": "JiraGoalsField"
          },
          {
            "name": "JiraIssueCreatedProformaFormsField"
          },
          {
            "name": "JiraIssueLinkField"
          },
          {
            "name": "JiraIssueLinkRelationshipTypeField"
          },
          {
            "name": "JiraIssueRestrictionField"
          },
          {
            "name": "JiraIssueTypeField"
          },
          {
            "name": "JiraLabelsField"
          },
          {
            "name": "JiraMultipleGroupPickerField"
          },
          {
            "name": "JiraMultipleSelectField"
          },
          {
            "name": "JiraMultipleSelectUserPickerField"
          },
          {
            "name": "JiraMultipleVersionPickerField"
          },
          {
            "name": "JiraNumberField"
          },
          {
            "name": "JiraNumberFormulaField"
          },
          {
            "name": "JiraOriginalTimeEstimateField"
          },
          {
            "name": "JiraParentIssueField"
          },
          {
            "name": "JiraPeopleField"
          },
          {
            "name": "JiraPriorityField"
          },
          {
            "name": "JiraProformaFormsField"
          },
          {
            "name": "JiraProjectField"
          },
          {
            "name": "JiraRadioSelectField"
          },
          {
            "name": "JiraRemainingTimeEstimateField"
          },
          {
            "name": "JiraRequestTypeField"
          },
          {
            "name": "JiraResolutionField"
          },
          {
            "name": "JiraRichTextField"
          },
          {
            "name": "JiraSecurityLevelField"
          },
          {
            "name": "JiraServiceManagementApprovalField"
          },
          {
            "name": "JiraServiceManagementChannelSourceField"
          },
          {
            "name": "JiraServiceManagementDateTimeField"
          },
          {
            "name": "JiraServiceManagementEntitlementField"
          },
          {
            "name": "JiraServiceManagementIncidentLinkingField"
          },
          {
            "name": "JiraServiceManagementMajorIncidentField"
          },
          {
            "name": "JiraServiceManagementMultipleSelectUserPickerField"
          },
          {
            "name": "JiraServiceManagementOrganizationField"
          },
          {
            "name": "JiraServiceManagementPeopleField"
          },
          {
            "name": "JiraServiceManagementRequestFeedbackField"
          },
          {
            "name": "JiraServiceManagementRequestLanguageField"
          },
          {
            "name": "JiraServiceManagementRequestTypeField"
          },
          {
            "name": "JiraServiceManagementRespondersField"
          },
          {
            "name": "JiraServiceManagementSentimentField"
          },
          {
            "name": "JiraServiceManagementSlaField"
          },
          {
            "name": "JiraSingleGroupPickerField"
          },
          {
            "name": "JiraSingleLineTextField"
          },
          {
            "name": "JiraSingleSelectField"
          },
          {
            "name": "JiraSingleSelectUserPickerField"
          },
          {
            "name": "JiraSingleVersionPickerField"
          },
          {
            "name": "JiraSprintField"
          },
          {
            "name": "JiraStatusCategoryField"
          },
          {
            "name": "JiraStatusField"
          },
          {
            "name": "JiraSubtasksField"
          },
          {
            "name": "JiraTeamField"
          },
          {
            "name": "JiraTeamViewField"
          },
          {
            "name": "JiraTextFormulaField"
          },
          {
            "name": "JiraTimeTrackingField"
          },
          {
            "name": "JiraTimelineField"
          },
          {
            "name": "JiraTownsquareProjectField"
          },
          {
            "name": "JiraUrlField"
          },
          {
            "name": "JiraVotesField"
          },
          {
            "name": "JiraWatchesField"
          },
          {
            "name": "JiraWorkCategoryField"
          },
          {
            "name": "JiraWorkLogField"
          },
          {
            "name": "JsmMultipleSelectUserPickerField"
          },
          {
            "name": "JsmOrganizationField"
          },
          {
            "name": "JsmPeopleField"
          },
          {
            "name": "JsmRequestTypeField"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraIssueFieldCreateContextOption",
        "possibleTypes": [
          {
            "name": "JiraLabelsForCreateField"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueFieldsByContainerTypesResult",
        "possibleTypes": [
          {
            "name": "JiraIssueFieldsByContainerTypes"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueItemContainerItem",
        "possibleTypes": [
          {
            "name": "JiraIssueItemFieldItem"
          },
          {
            "name": "JiraIssueItemPanelItem"
          },
          {
            "name": "JiraIssueItemGroupContainer"
          },
          {
            "name": "JiraIssueItemTabContainer"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueItemContainersResult",
        "possibleTypes": [
          {
            "name": "JiraIssueItemContainers"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueItemGroupContainerItem",
        "possibleTypes": [
          {
            "name": "JiraIssueItemFieldItem"
          },
          {
            "name": "JiraIssueItemPanelItem"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueItemTabContainerItem",
        "possibleTypes": [
          {
            "name": "JiraIssueItemFieldItem"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueLayout",
        "possibleTypes": [
          {
            "name": "JiraDefaultIssueLayout"
          },
          {
            "name": "JiraIssueCreateLayout"
          },
          {
            "name": "JiraLegacyIssueLayout"
          },
          {
            "name": "JsdDefaultIssueLayout"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueLayoutConfiguration",
        "possibleTypes": [
          {
            "name": "JiraIssueLayoutConfigurationResult"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueLayoutFieldConfigurationHiddenIn",
        "possibleTypes": [
          {
            "name": "JiraIssueLayoutFieldConfigurationHiddenInGlobal"
          },
          {
            "name": "JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueLayoutFieldPanelItemConfiguration",
        "possibleTypes": [
          {
            "name": "JiraIssueLayoutFieldItemConfiguration"
          },
          {
            "name": "JiraIssueLayoutPanelItemConfiguration"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueLayoutItemConfiguration",
        "possibleTypes": [
          {
            "name": "JiraIssueLayoutContainerConfiguration"
          },
          {
            "name": "JiraIssueLayoutFieldItemConfiguration"
          },
          {
            "name": "JiraIssueLayoutGroupContainerConfiguration"
          },
          {
            "name": "JiraIssueLayoutTabContainerConfiguration"
          },
          {
            "name": "JiraIssueLayoutPanelItemConfiguration"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueLayoutOwner",
        "possibleTypes": [
          {
            "name": "JiraIssueLayoutIssueTypeOwner"
          },
          {
            "name": "JiraIssueLayoutRequestTypeOwner"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueLayoutOwners",
        "possibleTypes": [
          {
            "name": "JiraIssueLayoutOwnersResult"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraIssuePillarContext",
        "possibleTypes": [
          {
            "name": "JiraJsmIssuePillarContextImpl"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueResult",
        "possibleTypes": [
          {
            "name": "JiraIssue"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraIssueSearchBulkViewContexts",
        "possibleTypes": [
          {
            "name": "JiraIssueSearchBulkViewGroupContexts"
          },
          {
            "name": "JiraIssueSearchBulkViewParentContexts"
          },
          {
            "name": "JiraIssueSearchBulkViewTopLevelContexts"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueSearchByFilterResult",
        "possibleTypes": [
          {
            "name": "JiraIssueSearchByFilter"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueSearchByJqlResult",
        "possibleTypes": [
          {
            "name": "JiraIssueSearchByJql"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueSearchError",
        "possibleTypes": [
          {
            "name": "JiraInvalidJqlError"
          },
          {
            "name": "JiraInvalidSyntaxError"
          },
          {
            "name": "JiraServerError"
          },
          {
            "name": "JiraCustomIssueSearchError"
          },
          {
            "name": "JiraJqlSearchRateLimitingError"
          },
          {
            "name": "JiraInvalidIssueSearchInputError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraIssueSearchResult",
        "possibleTypes": [
          {
            "name": "JiraIssueSearchByFilter"
          },
          {
            "name": "JiraIssueSearchByHydration"
          },
          {
            "name": "JiraIssueSearchByJql"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraIssueSearchResultContent",
        "possibleTypes": [
          {
            "name": "JiraIssueSearchContextlessContent"
          },
          {
            "name": "JiraIssueSearchContextualContent"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraIssueSearchViewContextMapping",
        "possibleTypes": [
          {
            "name": "JiraIssueSearchViewContextMappingByGroup"
          },
          {
            "name": "JiraIssueSearchViewContextMappingByParent"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraIssueSearchViewMetadata",
        "possibleTypes": [
          {
            "name": "JiraDetailedView"
          },
          {
            "name": "JiraGroupedListView"
          },
          {
            "name": "JiraGroupedTimelineView"
          },
          {
            "name": "JiraIssueSearchView"
          },
          {
            "name": "JiraListView"
          },
          {
            "name": "JiraTimelineView"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraIssueSearchViewResult",
        "possibleTypes": [
          {
            "name": "JiraIssueSearchView"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraJQLGenerationError",
        "possibleTypes": [
          {
            "name": "JiraInvalidJqlError"
          },
          {
            "name": "JiraInvalidSyntaxError"
          },
          {
            "name": "JiraServerError"
          },
          {
            "name": "JiraUIExposedError"
          },
          {
            "name": "JiraUsageLimitExceededError"
          },
          {
            "name": "JiraUnsupportedLanguageError"
          },
          {
            "name": "JiraGeneratedJqlInvalidError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraJourneyItem",
        "possibleTypes": [
          {
            "name": "JiraJourneyWorkItem"
          },
          {
            "name": "JiraJourneyStatusDependency"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraJourneyItemCommon",
        "possibleTypes": [
          {
            "name": "JiraJourneyStatusDependency"
          },
          {
            "name": "JiraJourneyWorkItem"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraJourneyParentIssueValueType",
        "possibleTypes": [
          {
            "name": "JiraServiceManagementRequestType"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraJourneyStep",
        "possibleTypes": [
          {
            "name": "JiraJourneyWorkItemStep"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraJourneyTriggerConfiguration",
        "possibleTypes": [
          {
            "name": "JiraJourneyWorkdayIntegrationTriggerConfiguration"
          },
          {
            "name": "JiraJourneyParentIssueTriggerConfiguration"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraJqlFieldConnectionResult",
        "possibleTypes": [
          {
            "name": "JiraJqlFieldConnection"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraJqlFieldValue",
        "possibleTypes": [
          {
            "name": "JiraJqlAtlasProjectFieldValue"
          },
          {
            "name": "JiraJqlCascadingOptionFieldValue"
          },
          {
            "name": "JiraJqlComponentFieldValue"
          },
          {
            "name": "JiraJqlDateBucketFieldValue"
          },
          {
            "name": "JiraJqlEmptyFieldValue"
          },
          {
            "name": "JiraJqlFocusAreasFieldValue"
          },
          {
            "name": "JiraJqlFunctionFieldValue"
          },
          {
            "name": "JiraJqlGoalsFieldValue"
          },
          {
            "name": "JiraJqlGroupFieldValue"
          },
          {
            "name": "JiraJqlIssueFieldValue"
          },
          {
            "name": "JiraJqlIssueTypeFieldValue"
          },
          {
            "name": "JiraJqlJwmCategoryOptionFieldValue"
          },
          {
            "name": "JiraJqlLabelFieldValue"
          },
          {
            "name": "JiraJqlNumberFieldValue"
          },
          {
            "name": "JiraJqlOptionFieldValue"
          },
          {
            "name": "JiraJqlPlainTextFieldValue"
          },
          {
            "name": "JiraJqlPriorityFieldValue"
          },
          {
            "name": "JiraJqlProjectFieldValue"
          },
          {
            "name": "JiraJqlResolutionFieldValue"
          },
          {
            "name": "JiraJqlSprintFieldValue"
          },
          {
            "name": "JiraJqlStatusCategoryFieldValue"
          },
          {
            "name": "JiraJqlStatusFieldValue"
          },
          {
            "name": "JiraJqlTeamFieldValue"
          },
          {
            "name": "JiraJqlTownsquareProjectFieldValue"
          },
          {
            "name": "JiraJqlUserFieldValue"
          },
          {
            "name": "JiraJqlVersionFieldValue"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraJqlHydratedQueryFieldsOnlyResult",
        "possibleTypes": [
          {
            "name": "JiraJqlHydratedQueryFieldsOnly"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraJqlHydratedQueryResult",
        "possibleTypes": [
          {
            "name": "JiraJqlHydratedQuery"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraJqlQueryHydratedFieldResult",
        "possibleTypes": [
          {
            "name": "JiraJqlQueryHydratedField"
          },
          {
            "name": "JiraJqlQueryHydratedError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraJqlQueryHydratedFieldsOnlyResult",
        "possibleTypes": [
          {
            "name": "JiraJqlQueryHydratedFieldOnly"
          },
          {
            "name": "JiraJqlQueryHydratedError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraJqlQueryHydratedValueResult",
        "possibleTypes": [
          {
            "name": "JiraJqlQueryHydratedValue"
          },
          {
            "name": "JiraJqlQueryHydratedError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraListRow",
        "possibleTypes": [
          {
            "name": "JiraIssue"
          },
          {
            "name": "JiraIssueLinkList"
          },
          {
            "name": "JiraRemoteIssueLinkList"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraListRowConnection",
        "possibleTypes": [
          {
            "name": "JiraIssueConnection"
          },
          {
            "name": "JiraLinkedIssueConnection"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraListRowEdge",
        "possibleTypes": [
          {
            "name": "JiraIssueEdge"
          },
          {
            "name": "JiraIssueLinkListEdge"
          },
          {
            "name": "JiraRemoteIssueLinkListEdge"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraListRowField",
        "possibleTypes": [
          {
            "name": "CalendarIssueField"
          },
          {
            "name": "GenericIssueField"
          },
          {
            "name": "JWMCategoryField"
          },
          {
            "name": "JiraAffectedServicesField"
          },
          {
            "name": "JiraAgentSessionsField"
          },
          {
            "name": "JiraAggregatedStatusField"
          },
          {
            "name": "JiraAggregatedTimelineField"
          },
          {
            "name": "JiraAssetField"
          },
          {
            "name": "JiraAtlasProjectField"
          },
          {
            "name": "JiraAtlassianTeamField"
          },
          {
            "name": "JiraAttachmentsField"
          },
          {
            "name": "JiraBoardCardCoverMediaField"
          },
          {
            "name": "JiraBooleanField"
          },
          {
            "name": "JiraCMDBField"
          },
          {
            "name": "JiraCascadingSelectField"
          },
          {
            "name": "JiraCheckboxesField"
          },
          {
            "name": "JiraColorField"
          },
          {
            "name": "JiraCommentSummaryField"
          },
          {
            "name": "JiraComponentsField"
          },
          {
            "name": "JiraConfluenceRemoteIssueLinksField"
          },
          {
            "name": "JiraConnectDateTimeField"
          },
          {
            "name": "JiraConnectMultipleSelectField"
          },
          {
            "name": "JiraConnectNumberField"
          },
          {
            "name": "JiraConnectReadOnlyField"
          },
          {
            "name": "JiraConnectRichTextField"
          },
          {
            "name": "JiraConnectSingleSelectField"
          },
          {
            "name": "JiraConnectTextField"
          },
          {
            "name": "JiraCustomerServiceOrganizationField"
          },
          {
            "name": "JiraDataClassificationField"
          },
          {
            "name": "JiraDateFormulaField"
          },
          {
            "name": "JiraDatePickerField"
          },
          {
            "name": "JiraDateRangeField"
          },
          {
            "name": "JiraDateTimePickerField"
          },
          {
            "name": "JiraDevSummaryField"
          },
          {
            "name": "JiraDurationField"
          },
          {
            "name": "JiraEpicLinkField"
          },
          {
            "name": "JiraFallbackField"
          },
          {
            "name": "JiraFlagField"
          },
          {
            "name": "JiraForgeDateField"
          },
          {
            "name": "JiraForgeDatetimeField"
          },
          {
            "name": "JiraForgeGroupField"
          },
          {
            "name": "JiraForgeGroupsField"
          },
          {
            "name": "JiraForgeNumberField"
          },
          {
            "name": "JiraForgeObjectField"
          },
          {
            "name": "JiraForgeStringField"
          },
          {
            "name": "JiraForgeStringsField"
          },
          {
            "name": "JiraForgeUserField"
          },
          {
            "name": "JiraForgeUsersField"
          },
          {
            "name": "JiraGoalsField"
          },
          {
            "name": "JiraIssueCreatedProformaFormsField"
          },
          {
            "name": "JiraIssueLinkField"
          },
          {
            "name": "JiraIssueLinkRelationshipTypeField"
          },
          {
            "name": "JiraIssueRestrictionField"
          },
          {
            "name": "JiraIssueTypeField"
          },
          {
            "name": "JiraLabelsField"
          },
          {
            "name": "JiraMultipleGroupPickerField"
          },
          {
            "name": "JiraMultipleSelectField"
          },
          {
            "name": "JiraMultipleSelectUserPickerField"
          },
          {
            "name": "JiraMultipleVersionPickerField"
          },
          {
            "name": "JiraNumberField"
          },
          {
            "name": "JiraNumberFormulaField"
          },
          {
            "name": "JiraOriginalTimeEstimateField"
          },
          {
            "name": "JiraParentIssueField"
          },
          {
            "name": "JiraPeopleField"
          },
          {
            "name": "JiraPriorityField"
          },
          {
            "name": "JiraProformaFormsField"
          },
          {
            "name": "JiraProjectField"
          },
          {
            "name": "JiraRadioSelectField"
          },
          {
            "name": "JiraRemainingTimeEstimateField"
          },
          {
            "name": "JiraRemoteGenericField"
          },
          {
            "name": "JiraRemoteIssueTypeField"
          },
          {
            "name": "JiraRemotePriorityField"
          },
          {
            "name": "JiraRemoteSingleLineTextField"
          },
          {
            "name": "JiraRemoteSingleSelectUserPickerField"
          },
          {
            "name": "JiraRemoteStatusField"
          },
          {
            "name": "JiraRequestTypeField"
          },
          {
            "name": "JiraResolutionField"
          },
          {
            "name": "JiraRichTextField"
          },
          {
            "name": "JiraSecurityLevelField"
          },
          {
            "name": "JiraServiceManagementApprovalField"
          },
          {
            "name": "JiraServiceManagementChannelSourceField"
          },
          {
            "name": "JiraServiceManagementDateTimeField"
          },
          {
            "name": "JiraServiceManagementEntitlementField"
          },
          {
            "name": "JiraServiceManagementIncidentLinkingField"
          },
          {
            "name": "JiraServiceManagementMajorIncidentField"
          },
          {
            "name": "JiraServiceManagementMultipleSelectUserPickerField"
          },
          {
            "name": "JiraServiceManagementOrganizationField"
          },
          {
            "name": "JiraServiceManagementPeopleField"
          },
          {
            "name": "JiraServiceManagementRequestFeedbackField"
          },
          {
            "name": "JiraServiceManagementRequestLanguageField"
          },
          {
            "name": "JiraServiceManagementRequestTypeField"
          },
          {
            "name": "JiraServiceManagementRespondersField"
          },
          {
            "name": "JiraServiceManagementSentimentField"
          },
          {
            "name": "JiraServiceManagementSlaField"
          },
          {
            "name": "JiraSingleGroupPickerField"
          },
          {
            "name": "JiraSingleLineTextField"
          },
          {
            "name": "JiraSingleSelectField"
          },
          {
            "name": "JiraSingleSelectUserPickerField"
          },
          {
            "name": "JiraSingleVersionPickerField"
          },
          {
            "name": "JiraSprintField"
          },
          {
            "name": "JiraStatusCategoryField"
          },
          {
            "name": "JiraStatusField"
          },
          {
            "name": "JiraSubtaskSummaryField"
          },
          {
            "name": "JiraSubtasksField"
          },
          {
            "name": "JiraTeamField"
          },
          {
            "name": "JiraTeamViewField"
          },
          {
            "name": "JiraTextFormulaField"
          },
          {
            "name": "JiraTimeTrackingField"
          },
          {
            "name": "JiraTimelineField"
          },
          {
            "name": "JiraTownsquareProjectField"
          },
          {
            "name": "JiraUrlField"
          },
          {
            "name": "JiraVotesField"
          },
          {
            "name": "JiraWatchesField"
          },
          {
            "name": "JiraWorkCategoryField"
          },
          {
            "name": "JiraWorkLogField"
          },
          {
            "name": "JsmMultipleSelectUserPickerField"
          },
          {
            "name": "JsmOrganizationField"
          },
          {
            "name": "JsmPeopleField"
          },
          {
            "name": "JsmRequestTypeField"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraListRowFieldConnection",
        "possibleTypes": [
          {
            "name": "JiraIssueFieldConnection"
          },
          {
            "name": "JiraRemoteIssueFieldConnection"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraListRowFieldEdge",
        "possibleTypes": [
          {
            "name": "JiraIssueFieldEdge"
          },
          {
            "name": "JiraRemoteIssueFieldEdge"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraListRowFieldSet",
        "possibleTypes": [
          {
            "name": "JiraIssueFieldSet"
          },
          {
            "name": "JiraRemoteIssueFieldSet"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraListRowFieldSetConnection",
        "possibleTypes": [
          {
            "name": "JiraIssueFieldSetConnection"
          },
          {
            "name": "JiraRemoteIssueFieldSetConnection"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraListRowFieldSetEdge",
        "possibleTypes": [
          {
            "name": "JiraIssueFieldSetEdge"
          },
          {
            "name": "JiraRemoteIssueFieldSetEdge"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraMediaUploadTokenResult",
        "possibleTypes": [
          {
            "name": "JiraMediaUploadToken"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraMergeIssuesOperationProgressResult",
        "possibleTypes": [
          {
            "name": "JiraMergeIssuesOperationProgress"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraMyFilterFieldConnectionResult",
        "possibleTypes": [
          {
            "name": "JiraMyFilterFieldConnection"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraNavigationItem",
        "possibleTypes": [
          {
            "name": "JiraAppNavigationItem"
          },
          {
            "name": "JiraShortcutNavigationItem"
          },
          {
            "name": "JiraSoftwareBuiltInNavigationItem"
          },
          {
            "name": "JiraWorkManagementSavedView"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraNavigationItemResult",
        "possibleTypes": [
          {
            "name": "JiraWorkManagementSavedView"
          },
          {
            "name": "JiraSoftwareBuiltInNavigationItem"
          },
          {
            "name": "JiraAppNavigationItem"
          },
          {
            "name": "JiraShortcutNavigationItem"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraNavigationItemType",
        "possibleTypes": [
          {
            "name": "JiraAppNavigationItemType"
          },
          {
            "name": "JiraSimpleNavigationItemType"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraNumberLikeField",
        "possibleTypes": [
          {
            "name": "JiraForgeNumberField"
          },
          {
            "name": "JiraNumberField"
          },
          {
            "name": "JiraNumberFormulaField"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraOnSuggestedChildIssueResult",
        "possibleTypes": [
          {
            "name": "JiraSuggestedIssue"
          },
          {
            "name": "JiraSuggestedChildIssueStatus"
          },
          {
            "name": "JiraSuggestedChildIssueError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraOverviewPlanMigrationStateResult",
        "possibleTypes": [
          {
            "name": "JiraOverviewPlanMigrationState"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraPermissionSchemeViewResult",
        "possibleTypes": [
          {
            "name": "JiraPermissionSchemeView"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraProjectConfiguration",
        "possibleTypes": [
          {
            "name": "JiraProjectConfigurationResult"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraProjectFieldAssociationInterface",
        "possibleTypes": [
          {
            "name": "JiraAvailableField"
          },
          {
            "name": "JiraFieldAssociationWithIssueTypes"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraProjectLevelSidebarMenuCustomizationResult",
        "possibleTypes": [
          {
            "name": "JiraProjectLevelSidebarMenuCustomization"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraProjectNavigationMetadata",
        "possibleTypes": [
          {
            "name": "JiraSoftwareProjectNavigationMetadata"
          },
          {
            "name": "JiraServiceManagementProjectNavigationMetadata"
          },
          {
            "name": "JiraWorkManagementProjectNavigationMetadata"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraProjectRecommendationDetails",
        "possibleTypes": [
          {
            "name": "JiraInviterActivityRecommendation"
          },
          {
            "name": "JiraTenantActivityRecommendation"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraProjectsUsingField",
        "possibleTypes": [
          {
            "name": "JiraProjectsUsingFieldResult"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraReleaseHistoryValue",
        "possibleTypes": [
          {
            "name": "JiraReleaseHistoryGenericFieldValue"
          },
          {
            "name": "JiraReleaseHistoryStatusFieldValue"
          },
          {
            "name": "JiraReleaseHistoryUserFieldValue"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraRemoteIssueField",
        "possibleTypes": [
          {
            "name": "JiraIssueLinkRelationshipTypeField"
          },
          {
            "name": "JiraRemoteGenericField"
          },
          {
            "name": "JiraRemoteIssueTypeField"
          },
          {
            "name": "JiraRemotePriorityField"
          },
          {
            "name": "JiraRemoteSingleLineTextField"
          },
          {
            "name": "JiraRemoteSingleSelectUserPickerField"
          },
          {
            "name": "JiraRemoteStatusField"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraRemoteIssueLink",
        "possibleTypes": [
          {
            "name": "JiraIssueRemoteIssueLink"
          },
          {
            "name": "JiraConfluenceRemoteIssueLink"
          },
          {
            "name": "JiraWebRemoteIssueLink"
          },
          {
            "name": "JiraCustomRemoteIssueLink"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraResourceUsageMetricV2",
        "possibleTypes": [
          {
            "name": "JiraCustomFieldOptionUsageMetric"
          },
          {
            "name": "JiraCustomFieldUsageMetric"
          },
          {
            "name": "JiraGenericResourceUsageMetric"
          },
          {
            "name": "JiraIssueSecurityLevelUsageMetric"
          },
          {
            "name": "JiraWorkTypeUsageMetric"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraScenarioIssueLike",
        "possibleTypes": [
          {
            "name": "JiraIssue"
          },
          {
            "name": "JiraScenarioIssue"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraScenarioVersionLike",
        "possibleTypes": [
          {
            "name": "JiraScenarioVersion"
          },
          {
            "name": "JiraVersion"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraSearchableEntity",
        "possibleTypes": [
          {
            "name": "JiraProject"
          },
          {
            "name": "JiraSystemFilter"
          },
          {
            "name": "JiraCustomFilter"
          },
          {
            "name": "JiraBoard"
          },
          {
            "name": "JiraDashboard"
          },
          {
            "name": "JiraIssue"
          },
          {
            "name": "JiraServiceManagementQueue"
          },
          {
            "name": "JiraPlan"
          },
          {
            "name": "JiraProductDiscoveryCollection"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraSectionLayoutItem",
        "possibleTypes": [
          {
            "name": "JiraGroupLayout"
          },
          {
            "name": "JiraTabLayout"
          },
          {
            "name": "JiraFieldLayoutItem"
          },
          {
            "name": "JiraEcosystemLayoutItem"
          },
          {
            "name": "JiraForgeLayoutItem"
          },
          {
            "name": "JiraPanelLayoutItem"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraSelectableValue",
        "possibleTypes": [
          {
            "name": "JiraAffectedService"
          },
          {
            "name": "JiraOption"
          },
          {
            "name": "JiraParentOption"
          },
          {
            "name": "JiraServiceManagementOrganization"
          },
          {
            "name": "JiraVersion"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraSelectedUsersField",
        "possibleTypes": [
          {
            "name": "JiraForgeUsersField"
          },
          {
            "name": "JiraMultipleSelectUserPickerField"
          },
          {
            "name": "JiraPeopleField"
          },
          {
            "name": "JiraServiceManagementMultipleSelectUserPickerField"
          },
          {
            "name": "JiraServiceManagementPeopleField"
          },
          {
            "name": "JiraVotesField"
          },
          {
            "name": "JiraWatchesField"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraServiceManagementApproverPrincipal",
        "possibleTypes": [
          {
            "name": "JiraServiceManagementUserApproverPrincipal"
          },
          {
            "name": "JiraServiceManagementGroupApproverPrincipal"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraServiceManagementEntitledEntity",
        "possibleTypes": [
          {
            "name": "JiraServiceManagementEntitlementCustomer"
          },
          {
            "name": "JiraServiceManagementEntitlementOrganization"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraServiceManagementRequestTypeFieldCommon",
        "possibleTypes": [
          {
            "name": "JiraServiceManagementAttachmentPreviewField"
          },
          {
            "name": "JiraServiceManagementDatePreviewField"
          },
          {
            "name": "JiraServiceManagementDateTimePreviewField"
          },
          {
            "name": "JiraServiceManagementDueDatePreviewField"
          },
          {
            "name": "JiraServiceManagementMultiCheckboxesPreviewField"
          },
          {
            "name": "JiraServiceManagementMultiSelectPreviewField"
          },
          {
            "name": "JiraServiceManagementMultiServicePickerPreviewField"
          },
          {
            "name": "JiraServiceManagementMultiUserPickerPreviewField"
          },
          {
            "name": "JiraServiceManagementPeoplePreviewField"
          },
          {
            "name": "JiraServiceManagementSelectPreviewField"
          },
          {
            "name": "JiraServiceManagementTextAreaPreviewField"
          },
          {
            "name": "JiraServiceManagementTextPreviewField"
          },
          {
            "name": "JiraServiceManagementUnknownPreviewField"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraServiceManagementRequestTypePreviewField",
        "possibleTypes": [
          {
            "name": "JiraServiceManagementTextPreviewField"
          },
          {
            "name": "JiraServiceManagementTextAreaPreviewField"
          },
          {
            "name": "JiraServiceManagementDueDatePreviewField"
          },
          {
            "name": "JiraServiceManagementDatePreviewField"
          },
          {
            "name": "JiraServiceManagementDateTimePreviewField"
          },
          {
            "name": "JiraServiceManagementAttachmentPreviewField"
          },
          {
            "name": "JiraServiceManagementSelectPreviewField"
          },
          {
            "name": "JiraServiceManagementMultiSelectPreviewField"
          },
          {
            "name": "JiraServiceManagementMultiUserPickerPreviewField"
          },
          {
            "name": "JiraServiceManagementMultiServicePickerPreviewField"
          },
          {
            "name": "JiraServiceManagementMultiCheckboxesPreviewField"
          },
          {
            "name": "JiraServiceManagementPeoplePreviewField"
          },
          {
            "name": "JiraServiceManagementUnknownPreviewField"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraServiceManagementResponder",
        "possibleTypes": [
          {
            "name": "JiraServiceManagementUserResponder"
          },
          {
            "name": "JiraServiceManagementTeamResponder"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraShareableEntityEditGrant",
        "possibleTypes": [
          {
            "name": "JiraShareableEntityGroupGrant"
          },
          {
            "name": "JiraShareableEntityProjectRoleGrant"
          },
          {
            "name": "JiraShareableEntityUserGrant"
          },
          {
            "name": "JiraShareableEntityProjectGrant"
          },
          {
            "name": "JiraShareableEntityUnknownProjectGrant"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraShareableEntityShareGrant",
        "possibleTypes": [
          {
            "name": "JiraShareableEntityGroupGrant"
          },
          {
            "name": "JiraShareableEntityProjectRoleGrant"
          },
          {
            "name": "JiraShareableEntityProjectGrant"
          },
          {
            "name": "JiraShareableEntityAnonymousAccessGrant"
          },
          {
            "name": "JiraShareableEntityAnyLoggedInUserGrant"
          },
          {
            "name": "JiraShareableEntityUnknownProjectGrant"
          },
          {
            "name": "JiraShareableEntityUserGrant"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraSmartLink",
        "possibleTypes": [
          {
            "name": "JiraBlockSmartLink"
          },
          {
            "name": "JiraEmbedSmartLink"
          },
          {
            "name": "JiraInlineSmartLink"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraSpreadsheetGroupFieldValue",
        "possibleTypes": [
          {
            "name": "AtlassianAccountUser"
          },
          {
            "name": "JiraOption"
          },
          {
            "name": "JiraStatus"
          },
          {
            "name": "JiraPriority"
          },
          {
            "name": "JiraStoryPoint"
          },
          {
            "name": "JiraGoal"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraSpreadsheetView",
        "possibleTypes": [
          {
            "name": "JiraGroupedListView"
          },
          {
            "name": "JiraGroupedTimelineView"
          },
          {
            "name": "JiraListView"
          },
          {
            "name": "JiraTimelineView"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraSupportsUpdatedDependentFields",
        "possibleTypes": [
          {
            "name": "JiraDateFieldPayload"
          },
          {
            "name": "JiraDateTimeFieldPayload"
          },
          {
            "name": "JiraNumberFieldPayload"
          },
          {
            "name": "JiraSingleLineTextFieldPayload"
          },
          {
            "name": "JiraStoryPointEstimateFieldPayload"
          },
          {
            "name": "JiraUrlFieldPayload"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraTextLikeField",
        "possibleTypes": [
          {
            "name": "JiraSingleLineTextField"
          },
          {
            "name": "JiraTextFormulaField"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraTimelineVirtualField",
        "possibleTypes": [
          {
            "name": "JiraAggregatedTimelineField"
          },
          {
            "name": "JiraTimelineField"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraUnsplashImageSearchPageResult",
        "possibleTypes": [
          {
            "name": "JiraUnsplashImageSearchPage"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraUserIssueFieldConfiguration",
        "possibleTypes": [
          {
            "name": "JWMCategoryField"
          },
          {
            "name": "JiraAffectedServicesField"
          },
          {
            "name": "JiraAgentSessionsField"
          },
          {
            "name": "JiraAssetField"
          },
          {
            "name": "JiraAtlasProjectField"
          },
          {
            "name": "JiraAtlassianTeamField"
          },
          {
            "name": "JiraAttachmentsField"
          },
          {
            "name": "JiraBooleanField"
          },
          {
            "name": "JiraCascadingSelectField"
          },
          {
            "name": "JiraCheckboxesField"
          },
          {
            "name": "JiraColorField"
          },
          {
            "name": "JiraComponentsField"
          },
          {
            "name": "JiraConnectDateTimeField"
          },
          {
            "name": "JiraConnectMultipleSelectField"
          },
          {
            "name": "JiraConnectNumberField"
          },
          {
            "name": "JiraConnectReadOnlyField"
          },
          {
            "name": "JiraConnectRichTextField"
          },
          {
            "name": "JiraConnectSingleSelectField"
          },
          {
            "name": "JiraConnectTextField"
          },
          {
            "name": "JiraCustomerServiceOrganizationField"
          },
          {
            "name": "JiraDataClassificationField"
          },
          {
            "name": "JiraDateFormulaField"
          },
          {
            "name": "JiraDatePickerField"
          },
          {
            "name": "JiraDateRangeField"
          },
          {
            "name": "JiraDateTimePickerField"
          },
          {
            "name": "JiraDurationField"
          },
          {
            "name": "JiraEpicLinkField"
          },
          {
            "name": "JiraFlagField"
          },
          {
            "name": "JiraForgeDateField"
          },
          {
            "name": "JiraForgeDatetimeField"
          },
          {
            "name": "JiraForgeGroupField"
          },
          {
            "name": "JiraForgeGroupsField"
          },
          {
            "name": "JiraForgeNumberField"
          },
          {
            "name": "JiraForgeObjectField"
          },
          {
            "name": "JiraForgeStringField"
          },
          {
            "name": "JiraForgeStringsField"
          },
          {
            "name": "JiraForgeUserField"
          },
          {
            "name": "JiraForgeUsersField"
          },
          {
            "name": "JiraGoalsField"
          },
          {
            "name": "JiraIssueCreatedProformaFormsField"
          },
          {
            "name": "JiraIssueLinkField"
          },
          {
            "name": "JiraIssueRestrictionField"
          },
          {
            "name": "JiraLabelsField"
          },
          {
            "name": "JiraMultipleGroupPickerField"
          },
          {
            "name": "JiraMultipleSelectField"
          },
          {
            "name": "JiraMultipleSelectUserPickerField"
          },
          {
            "name": "JiraMultipleVersionPickerField"
          },
          {
            "name": "JiraNumberField"
          },
          {
            "name": "JiraNumberFormulaField"
          },
          {
            "name": "JiraOriginalTimeEstimateField"
          },
          {
            "name": "JiraParentIssueField"
          },
          {
            "name": "JiraPeopleField"
          },
          {
            "name": "JiraPriorityField"
          },
          {
            "name": "JiraProformaFormsField"
          },
          {
            "name": "JiraProjectField"
          },
          {
            "name": "JiraRadioSelectField"
          },
          {
            "name": "JiraRemainingTimeEstimateField"
          },
          {
            "name": "JiraResolutionField"
          },
          {
            "name": "JiraRichTextField"
          },
          {
            "name": "JiraSecurityLevelField"
          },
          {
            "name": "JiraServiceManagementApprovalField"
          },
          {
            "name": "JiraServiceManagementChannelSourceField"
          },
          {
            "name": "JiraServiceManagementDateTimeField"
          },
          {
            "name": "JiraServiceManagementEntitlementField"
          },
          {
            "name": "JiraServiceManagementMajorIncidentField"
          },
          {
            "name": "JiraServiceManagementMultipleSelectUserPickerField"
          },
          {
            "name": "JiraServiceManagementOrganizationField"
          },
          {
            "name": "JiraServiceManagementPeopleField"
          },
          {
            "name": "JiraServiceManagementRequestFeedbackField"
          },
          {
            "name": "JiraServiceManagementRequestLanguageField"
          },
          {
            "name": "JiraServiceManagementSentimentField"
          },
          {
            "name": "JiraSingleGroupPickerField"
          },
          {
            "name": "JiraSingleLineTextField"
          },
          {
            "name": "JiraSingleSelectField"
          },
          {
            "name": "JiraSingleSelectUserPickerField"
          },
          {
            "name": "JiraSingleVersionPickerField"
          },
          {
            "name": "JiraSprintField"
          },
          {
            "name": "JiraStatusCategoryField"
          },
          {
            "name": "JiraStatusField"
          },
          {
            "name": "JiraTeamField"
          },
          {
            "name": "JiraTeamViewField"
          },
          {
            "name": "JiraTextFormulaField"
          },
          {
            "name": "JiraTimeTrackingField"
          },
          {
            "name": "JiraTownsquareProjectField"
          },
          {
            "name": "JiraUrlField"
          },
          {
            "name": "JiraVotesField"
          },
          {
            "name": "JiraWatchesField"
          },
          {
            "name": "JiraWorkLogField"
          },
          {
            "name": "JsmMultipleSelectUserPickerField"
          },
          {
            "name": "JsmOrganizationField"
          },
          {
            "name": "JsmPeopleField"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraVersionConnectionResult",
        "possibleTypes": [
          {
            "name": "JiraVersionConnection"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraVersionRelatedWorkV2",
        "possibleTypes": [
          {
            "name": "JiraVersionRelatedWorkConfluenceReleaseNotes"
          },
          {
            "name": "JiraVersionRelatedWorkGenericLink"
          },
          {
            "name": "JiraVersionRelatedWorkNativeReleaseNotes"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraVersionResult",
        "possibleTypes": [
          {
            "name": "JiraVersion"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraView",
        "possibleTypes": [
          {
            "name": "JiraBacklogView"
          },
          {
            "name": "JiraBoardView"
          },
          {
            "name": "JiraDetailedView"
          },
          {
            "name": "JiraGroupedListView"
          },
          {
            "name": "JiraGroupedTimelineView"
          },
          {
            "name": "JiraListView"
          },
          {
            "name": "JiraTimelineView"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraViewResult",
        "possibleTypes": [
          {
            "name": "JiraBoardView"
          },
          {
            "name": "JiraBacklogView"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraWebItemTarget",
        "possibleTypes": [
          {
            "name": "JiraWebItemTargetDialog"
          },
          {
            "name": "JiraWebItemTargetDialogModule"
          },
          {
            "name": "JiraWebItemTargetInlineDialog"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraWorkManagementActiveBackgroundDetailsResult",
        "possibleTypes": [
          {
            "name": "JiraWorkManagementColorBackground"
          },
          {
            "name": "JiraWorkManagementGradientBackground"
          },
          {
            "name": "JiraWorkManagementMediaBackground"
          },
          {
            "name": "JiraWorkManagementAttachmentBackground"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JiraWorkManagementBackground",
        "possibleTypes": [
          {
            "name": "JiraWorkManagementAttachmentBackground"
          },
          {
            "name": "JiraWorkManagementColorBackground"
          },
          {
            "name": "JiraWorkManagementGradientBackground"
          },
          {
            "name": "JiraWorkManagementMediaBackground"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraWorkManagementBackgroundUploadTokenResult",
        "possibleTypes": [
          {
            "name": "JiraWorkManagementBackgroundUploadToken"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraWorkManagementCategoryOptionConnectionResult",
        "possibleTypes": [
          {
            "name": "JiraWorkManagementCategoryOptionConnection"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraWorkManagementFieldConfigurationConnectionResult",
        "possibleTypes": [
          {
            "name": "JiraWorkManagementFieldConfigurationConnection"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraWorkManagementFilterConnectionResult",
        "possibleTypes": [
          {
            "name": "JiraWorkManagementFilterConnection"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraWorkManagementGiraOverviewResult",
        "possibleTypes": [
          {
            "name": "JiraWorkManagementGiraOverview"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraWorkManagementSavedViewResult",
        "possibleTypes": [
          {
            "name": "JiraWorkManagementSavedView"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JiraWorkManagementViewItemConnectionResult",
        "possibleTypes": [
          {
            "name": "JiraWorkManagementViewItemConnection"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JqlFieldConnectionResult",
        "possibleTypes": [
          {
            "name": "JqlFieldConnection"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JqlFieldValue",
        "possibleTypes": [
          {
            "name": "JqlCascadingOptionFieldValue"
          },
          {
            "name": "JqlComponentFieldValue"
          },
          {
            "name": "JqlGroupFieldValue"
          },
          {
            "name": "JqlIssueFieldValue"
          },
          {
            "name": "JqlIssueTypeFieldValue"
          },
          {
            "name": "JqlJwmCategoryOptionFieldValue"
          },
          {
            "name": "JqlLabelFieldValue"
          },
          {
            "name": "JqlOptionFieldValue"
          },
          {
            "name": "JqlPriorityFieldValue"
          },
          {
            "name": "JqlProjectFieldValue"
          },
          {
            "name": "JqlResolutionFieldValue"
          },
          {
            "name": "JqlSprintFieldValue"
          },
          {
            "name": "JqlStatusCategoryFieldValue"
          },
          {
            "name": "JqlStatusFieldValue"
          },
          {
            "name": "JqlUserFieldValue"
          },
          {
            "name": "JqlVersionFieldValue"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JqlHydratedQueryResult",
        "possibleTypes": [
          {
            "name": "JqlHydratedQuery"
          },
          {
            "name": "QueryError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JqlQueryHydratedFieldResult",
        "possibleTypes": [
          {
            "name": "JqlQueryHydratedField"
          },
          {
            "name": "JqlQueryHydratedError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "JqlQueryHydratedValueResult",
        "possibleTypes": [
          {
            "name": "JqlQueryHydratedValue"
          },
          {
            "name": "JqlQueryHydratedError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "JswMutationResponse",
        "possibleTypes": [
          {
            "name": "AssignIssueOutput"
          },
          {
            "name": "CompleteSprintOutput"
          },
          {
            "name": "CreateSprintOutput"
          },
          {
            "name": "GenericMutationResponse"
          },
          {
            "name": "IssueParentCreateOutput"
          },
          {
            "name": "MoveSprintDownOutput"
          },
          {
            "name": "MoveSprintUpOutput"
          },
          {
            "name": "SetSwimlaneStrategyOutput"
          },
          {
            "name": "SprintOutput"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "LayoutDefiner",
        "possibleTypes": [
          {
            "name": "FieldLayoutScreen"
          },
          {
            "name": "JiraRequestType"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "LocalizationContext",
        "possibleTypes": [
          {
            "name": "AtlassianAccountUser"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "MediaUploadTokenUnion",
        "possibleTypes": [
          {
            "name": "MediaUploadToken"
          },
          {
            "name": "FailedMediaUploadToken"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "MercuryOriginalProjectStatus",
        "possibleTypes": [
          {
            "name": "JiraStatus"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "MercuryProjectStatus",
        "possibleTypes": [
          {
            "name": "JiraStatusCategory"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "MercuryProjectType",
        "possibleTypes": [
          {
            "name": "JiraIssueType"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "MergedFieldUnion",
        "possibleTypes": [
          {
            "name": "IssueTypeField"
          },
          {
            "name": "StatusField"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "MutationErrorExtension",
        "possibleTypes": [
          {
            "name": "FieldValidationMutationErrorExtension"
          },
          {
            "name": "GenericMutationErrorExtension"
          },
          {
            "name": "JWMTransitionAndRankMutationErrorExtension"
          },
          {
            "name": "JiraFilterEditGrantMutationErrorExtension"
          },
          {
            "name": "JiraFilterNameMutationErrorExtension"
          },
          {
            "name": "JiraFilterShareGrantMutationErrorExtension"
          },
          {
            "name": "JiraIssueArchiveAsyncErrorExtension"
          },
          {
            "name": "JiraIssueArchiveErrorExtension"
          },
          {
            "name": "JiraIssueUnarchiveErrorExtension"
          },
          {
            "name": "JiraListSettingMigrationMutationErrorExtension"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "MutationResponse",
        "possibleTypes": [
          {
            "name": "SetMyPreferenceOutput"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Node",
        "possibleTypes": [
          {
            "name": "ActivityFeedItem"
          },
          {
            "name": "ApprovalActivityItem"
          },
          {
            "name": "AvailableCardLayoutField"
          },
          {
            "name": "BasicBoardFeatureView"
          },
          {
            "name": "BoardFeatureGroup"
          },
          {
            "name": "BoardScope"
          },
          {
            "name": "CalendarIssueField"
          },
          {
            "name": "CardColor"
          },
          {
            "name": "Comment"
          },
          {
            "name": "ConfluencePage"
          },
          {
            "name": "CurrentCardLayoutField"
          },
          {
            "name": "CustomFilter"
          },
          {
            "name": "CustomSwimlane"
          },
          {
            "name": "Dashboard"
          },
          {
            "name": "EstimationBoardFeatureView"
          },
          {
            "name": "FailedRemoteLink"
          },
          {
            "name": "FieldConfig"
          },
          {
            "name": "GadgetSpec"
          },
          {
            "name": "GenericIssueField"
          },
          {
            "name": "IncidentActivityItem"
          },
          {
            "name": "Issue"
          },
          {
            "name": "IssueParent"
          },
          {
            "name": "JWMCategoryField"
          },
          {
            "name": "JWMItemGroup"
          },
          {
            "name": "JiraAffectedServicesField"
          },
          {
            "name": "JiraAgentSessionsField"
          },
          {
            "name": "JiraAggregatedStatusField"
          },
          {
            "name": "JiraAggregatedTimelineField"
          },
          {
            "name": "JiraAnnouncementBanner"
          },
          {
            "name": "JiraAppConfigState"
          },
          {
            "name": "JiraAppNavigationItem"
          },
          {
            "name": "JiraAppNavigationItemType"
          },
          {
            "name": "JiraApplicationProperty"
          },
          {
            "name": "JiraAssetField"
          },
          {
            "name": "JiraAtlasProject"
          },
          {
            "name": "JiraAtlasProjectField"
          },
          {
            "name": "JiraAtlassianTeamField"
          },
          {
            "name": "JiraAttachmentsField"
          },
          {
            "name": "JiraAutodevJob"
          },
          {
            "name": "JiraBacklogView"
          },
          {
            "name": "JiraBacklogViewColumnCardList"
          },
          {
            "name": "JiraBacklogViewSprintCardList"
          },
          {
            "name": "JiraBoard"
          },
          {
            "name": "JiraBoardCardCoverMediaField"
          },
          {
            "name": "JiraBoardView"
          },
          {
            "name": "JiraBoardViewAssigneeColumn"
          },
          {
            "name": "JiraBoardViewCategoryColumn"
          },
          {
            "name": "JiraBoardViewCell"
          },
          {
            "name": "JiraBoardViewColumnLayout"
          },
          {
            "name": "JiraBoardViewFieldSwimlane"
          },
          {
            "name": "JiraBoardViewPriorityColumn"
          },
          {
            "name": "JiraBoardViewStatusColumn"
          },
          {
            "name": "JiraBoardViewSwimlaneLayout"
          },
          {
            "name": "JiraBooleanField"
          },
          {
            "name": "JiraBulkEditField"
          },
          {
            "name": "JiraBulkTransition"
          },
          {
            "name": "JiraBulkTransitionScreenLayout"
          },
          {
            "name": "JiraBusinessAvailableFields"
          },
          {
            "name": "JiraBusinessFormConfiguration"
          },
          {
            "name": "JiraCMDBField"
          },
          {
            "name": "JiraCascadingSelectField"
          },
          {
            "name": "JiraCheckboxesField"
          },
          {
            "name": "JiraColorField"
          },
          {
            "name": "JiraCommentSummaryField"
          },
          {
            "name": "JiraComponent"
          },
          {
            "name": "JiraComponentsField"
          },
          {
            "name": "JiraConfluenceRemoteIssueLinksField"
          },
          {
            "name": "JiraConnectDateTimeField"
          },
          {
            "name": "JiraConnectMultipleSelectField"
          },
          {
            "name": "JiraConnectNumberField"
          },
          {
            "name": "JiraConnectReadOnlyField"
          },
          {
            "name": "JiraConnectRichTextField"
          },
          {
            "name": "JiraConnectSingleSelectField"
          },
          {
            "name": "JiraConnectTextField"
          },
          {
            "name": "JiraContainerNavigation"
          },
          {
            "name": "JiraContext"
          },
          {
            "name": "JiraCrossProjectVersion"
          },
          {
            "name": "JiraCustomFieldOptionUsageMetric"
          },
          {
            "name": "JiraCustomFieldUsageMetric"
          },
          {
            "name": "JiraCustomFilter"
          },
          {
            "name": "JiraCustomerServiceOrganizationField"
          },
          {
            "name": "JiraDashboard"
          },
          {
            "name": "JiraDataClassificationField"
          },
          {
            "name": "JiraDateFormulaField"
          },
          {
            "name": "JiraDatePickerField"
          },
          {
            "name": "JiraDateRangeField"
          },
          {
            "name": "JiraDateTimePickerField"
          },
          {
            "name": "JiraDefaultGrantTypeValue"
          },
          {
            "name": "JiraDetailedView"
          },
          {
            "name": "JiraDevSummaryField"
          },
          {
            "name": "JiraDurationField"
          },
          {
            "name": "JiraEntityPropertyBoolean"
          },
          {
            "name": "JiraEntityPropertyInt"
          },
          {
            "name": "JiraEntityPropertyJSON"
          },
          {
            "name": "JiraEntityPropertyLastDismissedAnnouncementBanner"
          },
          {
            "name": "JiraEntityPropertyString"
          },
          {
            "name": "JiraEpicLinkField"
          },
          {
            "name": "JiraFallbackField"
          },
          {
            "name": "JiraFavouriteValue"
          },
          {
            "name": "JiraFieldScheme"
          },
          {
            "name": "JiraFieldSetView"
          },
          {
            "name": "JiraFilterEmailSubscription"
          },
          {
            "name": "JiraFlagField"
          },
          {
            "name": "JiraFocusArea"
          },
          {
            "name": "JiraForgeDateField"
          },
          {
            "name": "JiraForgeDatetimeField"
          },
          {
            "name": "JiraForgeGroupField"
          },
          {
            "name": "JiraForgeGroupsField"
          },
          {
            "name": "JiraForgeNumberField"
          },
          {
            "name": "JiraForgeObjectField"
          },
          {
            "name": "JiraForgeStringField"
          },
          {
            "name": "JiraForgeStringsField"
          },
          {
            "name": "JiraForgeUserField"
          },
          {
            "name": "JiraForgeUsersField"
          },
          {
            "name": "JiraFormForPublicSubmissionConfiguration"
          },
          {
            "name": "JiraFormattingRule"
          },
          {
            "name": "JiraFormulaFieldExpressionConfig"
          },
          {
            "name": "JiraGenericResourceUsageMetric"
          },
          {
            "name": "JiraGoal"
          },
          {
            "name": "JiraGoalsField"
          },
          {
            "name": "JiraGroup"
          },
          {
            "name": "JiraGroupGrantTypeValue"
          },
          {
            "name": "JiraGroupedListView"
          },
          {
            "name": "JiraGroupedTimelineView"
          },
          {
            "name": "JiraGuest"
          },
          {
            "name": "JiraIssue"
          },
          {
            "name": "JiraIssueCommandPaletteUpdateFieldAction"
          },
          {
            "name": "JiraIssueCreatedProformaFormsField"
          },
          {
            "name": "JiraIssueFieldConfig"
          },
          {
            "name": "JiraIssueFieldGrantTypeValue"
          },
          {
            "name": "JiraIssueGenericCommandPaletteAction"
          },
          {
            "name": "JiraIssueLinkField"
          },
          {
            "name": "JiraIssueLinkRelationshipTypeField"
          },
          {
            "name": "JiraIssueLinkType"
          },
          {
            "name": "JiraIssueLinkTypeRelation"
          },
          {
            "name": "JiraIssueRestrictionField"
          },
          {
            "name": "JiraIssueSearchView"
          },
          {
            "name": "JiraIssueSecurityLevelUsageMetric"
          },
          {
            "name": "JiraIssueType"
          },
          {
            "name": "JiraIssueTypeField"
          },
          {
            "name": "JiraJQLHistory"
          },
          {
            "name": "JiraJourney"
          },
          {
            "name": "JiraJourneyConfiguration"
          },
          {
            "name": "JiraJourneyWorkItemStep"
          },
          {
            "name": "JiraLabelsField"
          },
          {
            "name": "JiraLabelsForCreateField"
          },
          {
            "name": "JiraListView"
          },
          {
            "name": "JiraMultipleGroupPickerField"
          },
          {
            "name": "JiraMultipleSelectField"
          },
          {
            "name": "JiraMultipleSelectUserPickerField"
          },
          {
            "name": "JiraMultipleVersionPickerField"
          },
          {
            "name": "JiraNavigationUIStateUserProperty"
          },
          {
            "name": "JiraNumberField"
          },
          {
            "name": "JiraNumberFormulaField"
          },
          {
            "name": "JiraOpsgenieTeam"
          },
          {
            "name": "JiraOption"
          },
          {
            "name": "JiraOriginalTimeEstimateField"
          },
          {
            "name": "JiraParentIssueField"
          },
          {
            "name": "JiraParentOption"
          },
          {
            "name": "JiraPeopleField"
          },
          {
            "name": "JiraPermissionScheme"
          },
          {
            "name": "JiraPlan"
          },
          {
            "name": "JiraPlatformAttachment"
          },
          {
            "name": "JiraPlatformComment"
          },
          {
            "name": "JiraPostIncidentReviewLink"
          },
          {
            "name": "JiraPriority"
          },
          {
            "name": "JiraPriorityField"
          },
          {
            "name": "JiraProductDiscoveryCollection"
          },
          {
            "name": "JiraProformaFormsField"
          },
          {
            "name": "JiraProject"
          },
          {
            "name": "JiraProjectAISummary"
          },
          {
            "name": "JiraProjectAccessRequestDetails"
          },
          {
            "name": "JiraProjectCategory"
          },
          {
            "name": "JiraProjectField"
          },
          {
            "name": "JiraProjectPolicy"
          },
          {
            "name": "JiraProjectRoleGrantTypeValue"
          },
          {
            "name": "JiraProjectShortcut"
          },
          {
            "name": "JiraProjectTypeDetails"
          },
          {
            "name": "JiraRadioSelectField"
          },
          {
            "name": "JiraRemainingTimeEstimateField"
          },
          {
            "name": "JiraRequestType"
          },
          {
            "name": "JiraRequestTypeField"
          },
          {
            "name": "JiraResolution"
          },
          {
            "name": "JiraResolutionField"
          },
          {
            "name": "JiraResource"
          },
          {
            "name": "JiraResourceUsageMetric"
          },
          {
            "name": "JiraRichTextField"
          },
          {
            "name": "JiraRole"
          },
          {
            "name": "JiraScenario"
          },
          {
            "name": "JiraScenarioIssue"
          },
          {
            "name": "JiraScenarioVersion"
          },
          {
            "name": "JiraScreen"
          },
          {
            "name": "JiraSecurityLevel"
          },
          {
            "name": "JiraSecurityLevelField"
          },
          {
            "name": "JiraServiceManagementActiveApproval"
          },
          {
            "name": "JiraServiceManagementApprovalField"
          },
          {
            "name": "JiraServiceManagementAttachment"
          },
          {
            "name": "JiraServiceManagementChannelSourceField"
          },
          {
            "name": "JiraServiceManagementComment"
          },
          {
            "name": "JiraServiceManagementCompletedApproval"
          },
          {
            "name": "JiraServiceManagementDateTimeField"
          },
          {
            "name": "JiraServiceManagementEntitlement"
          },
          {
            "name": "JiraServiceManagementEntitlementField"
          },
          {
            "name": "JiraServiceManagementIncidentLinkingField"
          },
          {
            "name": "JiraServiceManagementMajorIncidentField"
          },
          {
            "name": "JiraServiceManagementMultipleSelectUserPickerField"
          },
          {
            "name": "JiraServiceManagementOrganizationField"
          },
          {
            "name": "JiraServiceManagementPeopleField"
          },
          {
            "name": "JiraServiceManagementProduct"
          },
          {
            "name": "JiraServiceManagementQueue"
          },
          {
            "name": "JiraServiceManagementRequestFeedbackField"
          },
          {
            "name": "JiraServiceManagementRequestLanguageField"
          },
          {
            "name": "JiraServiceManagementRequestType"
          },
          {
            "name": "JiraServiceManagementRequestTypeField"
          },
          {
            "name": "JiraServiceManagementRespondersField"
          },
          {
            "name": "JiraServiceManagementSentimentField"
          },
          {
            "name": "JiraServiceManagementSlaField"
          },
          {
            "name": "JiraShortcutNavigationItem"
          },
          {
            "name": "JiraSimpleNavigationItemType"
          },
          {
            "name": "JiraSingleGroupPickerField"
          },
          {
            "name": "JiraSingleLineTextField"
          },
          {
            "name": "JiraSingleSelectField"
          },
          {
            "name": "JiraSingleSelectUserPickerField"
          },
          {
            "name": "JiraSingleVersionPickerField"
          },
          {
            "name": "JiraSoftwareBuiltInNavigationItem"
          },
          {
            "name": "JiraSoftwareCustomFilter"
          },
          {
            "name": "JiraSprint"
          },
          {
            "name": "JiraSprintField"
          },
          {
            "name": "JiraStatus"
          },
          {
            "name": "JiraStatusCategory"
          },
          {
            "name": "JiraStatusCategoryField"
          },
          {
            "name": "JiraStatusField"
          },
          {
            "name": "JiraSubmitBulkOperationProgress"
          },
          {
            "name": "JiraSubtaskSummaryField"
          },
          {
            "name": "JiraSubtasksField"
          },
          {
            "name": "JiraSuggestedIssueFieldValue"
          },
          {
            "name": "JiraSystemFilter"
          },
          {
            "name": "JiraTeam"
          },
          {
            "name": "JiraTeamField"
          },
          {
            "name": "JiraTeamViewField"
          },
          {
            "name": "JiraTextFormulaField"
          },
          {
            "name": "JiraTimeTrackingField"
          },
          {
            "name": "JiraTimelineField"
          },
          {
            "name": "JiraTimelineView"
          },
          {
            "name": "JiraTownsquareProject"
          },
          {
            "name": "JiraTownsquareProjectField"
          },
          {
            "name": "JiraTransition"
          },
          {
            "name": "JiraUrlField"
          },
          {
            "name": "JiraUserBroadcastMessage"
          },
          {
            "name": "JiraUserGrantTypeValue"
          },
          {
            "name": "JiraUserNavigationConfiguration"
          },
          {
            "name": "JiraVersion"
          },
          {
            "name": "JiraVersionApprover"
          },
          {
            "name": "JiraVotesField"
          },
          {
            "name": "JiraWatchesField"
          },
          {
            "name": "JiraWebItem"
          },
          {
            "name": "JiraWorkCategoryField"
          },
          {
            "name": "JiraWorkLogField"
          },
          {
            "name": "JiraWorkManagementFilter"
          },
          {
            "name": "JiraWorkManagementGiraOverview"
          },
          {
            "name": "JiraWorkManagementSavedView"
          },
          {
            "name": "JiraWorkManagementSavedViewType"
          },
          {
            "name": "JiraWorkManagementViewItem"
          },
          {
            "name": "JiraWorkTypeUsageMetric"
          },
          {
            "name": "JiraWorklog"
          },
          {
            "name": "JsmMultipleSelectUserPickerField"
          },
          {
            "name": "JsmOrganizationField"
          },
          {
            "name": "JsmPeopleField"
          },
          {
            "name": "JsmRequestType"
          },
          {
            "name": "JsmRequestTypeField"
          },
          {
            "name": "Project"
          },
          {
            "name": "Region"
          },
          {
            "name": "TimeZone"
          },
          {
            "name": "UserValue"
          },
          {
            "name": "ViewIssue"
          },
          {
            "name": "Worklog"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Payload",
        "possibleTypes": [
          {
            "name": "ActivitySortPreferencePayload"
          },
          {
            "name": "CopyIssueViewLayoutPayload"
          },
          {
            "name": "JWMConfluenceLinkPayload"
          },
          {
            "name": "JWMConfluenceUnlinkPayload"
          },
          {
            "name": "JWMCreateCategoryPayload"
          },
          {
            "name": "JWMDeleteCategoryPayload"
          },
          {
            "name": "JWMLinkItemsPayload"
          },
          {
            "name": "JWMScheduleTimelineItemPayload"
          },
          {
            "name": "JWMSetCollapsedStatusBoardColumnUserPreferencePayload"
          },
          {
            "name": "JWMTransitionAndRankItemPayload"
          },
          {
            "name": "JWMUnlinkItemsPayload"
          },
          {
            "name": "JWMUpdateCategoryPayload"
          },
          {
            "name": "JiraActivitySortOrderPayload"
          },
          {
            "name": "JiraAddAgentToBoardViewStatusColumnPayload"
          },
          {
            "name": "JiraAddAttachmentsPayload"
          },
          {
            "name": "JiraAddBoardViewStatusColumnPayload"
          },
          {
            "name": "JiraAddFieldsToFieldSchemePayload"
          },
          {
            "name": "JiraAddFieldsToProjectPayload"
          },
          {
            "name": "JiraAddIssuesToFixVersionPayload"
          },
          {
            "name": "JiraAddPostIncidentReviewLinkMutationPayload"
          },
          {
            "name": "JiraAddRelatedWorkToVersionPayload"
          },
          {
            "name": "JiraAffectedServicesFieldPayload"
          },
          {
            "name": "JiraAnswerApprovalDecisionPayload"
          },
          {
            "name": "JiraApproveJiraBitbucketWorkspaceAccessRequestPayload"
          },
          {
            "name": "JiraAssignRelatedWorkPayload"
          },
          {
            "name": "JiraAssociateProjectToFieldSchemePayload"
          },
          {
            "name": "JiraAttachmentFieldPayload"
          },
          {
            "name": "JiraAutodevBasicPayload"
          },
          {
            "name": "JiraAutodevCreateJobPayload"
          },
          {
            "name": "JiraAutodevDeletedPayload"
          },
          {
            "name": "JiraAutodevPlannedChangePayload"
          },
          {
            "name": "JiraAutodevTaskPayload"
          },
          {
            "name": "JiraBoardViewIssueCreatePayload"
          },
          {
            "name": "JiraBulkCleanupProjectsPayload"
          },
          {
            "name": "JiraBulkCreateIssueLinksPayload"
          },
          {
            "name": "JiraBulkLabelColorUpdatePayload"
          },
          {
            "name": "JiraBulkSetBoardViewColumnStatePayload"
          },
          {
            "name": "JiraBulkSetBoardViewSwimlaneStatePayload"
          },
          {
            "name": "JiraBusinessCreateFormPayload"
          },
          {
            "name": "JiraBusinessCreateIssuePayload"
          },
          {
            "name": "JiraBusinessDeleteFormPayload"
          },
          {
            "name": "JiraBusinessUpdateFormPayload"
          },
          {
            "name": "JiraCFOCreateRecommendationsPayload"
          },
          {
            "name": "JiraCascadingSelectFieldPayload"
          },
          {
            "name": "JiraCheckboxesFieldPayload"
          },
          {
            "name": "JiraClearBoardIssueCardCoverPayload"
          },
          {
            "name": "JiraCloneIssueResponse"
          },
          {
            "name": "JiraCmdbFieldPayload"
          },
          {
            "name": "JiraColorFieldPayload"
          },
          {
            "name": "JiraComponentsFieldPayload"
          },
          {
            "name": "JiraConnectTownsquareProjectPayload"
          },
          {
            "name": "JiraCreateApproverListFieldPayload"
          },
          {
            "name": "JiraCreateAttachmentBackgroundPayload"
          },
          {
            "name": "JiraCreateBoardPayload"
          },
          {
            "name": "JiraCreateBoardViewStatusColumnPayload"
          },
          {
            "name": "JiraCreateBoardViewsForWorkflowsPayload"
          },
          {
            "name": "JiraCreateCalendarIssuePayload"
          },
          {
            "name": "JiraCreateCategoryOptionPayload"
          },
          {
            "name": "JiraCreateCustomBackgroundPayload"
          },
          {
            "name": "JiraCreateCustomFieldPayload"
          },
          {
            "name": "JiraCreateCustomFilterPayload"
          },
          {
            "name": "JiraCreateFormattingRulePayload"
          },
          {
            "name": "JiraCreateGlobalCustomFieldPayload"
          },
          {
            "name": "JiraCreateIssueByPublicFormPayload"
          },
          {
            "name": "JiraCreateIssueSearchFormattingRulePayload"
          },
          {
            "name": "JiraCreateJourneyConfigurationPayload"
          },
          {
            "name": "JiraCreateNavigationItemPayload"
          },
          {
            "name": "JiraCreateProjectCleanupRecommendationsPayload"
          },
          {
            "name": "JiraCreateReleaseNoteConfluencePagePayload"
          },
          {
            "name": "JiraCreateTownsquareProjectAndConnectToSpacePayload"
          },
          {
            "name": "JiraCustomerServiceOrganizationFieldPayload"
          },
          {
            "name": "JiraDataClassificationFieldPayload"
          },
          {
            "name": "JiraDateFieldAssociationMessageMutationPayload"
          },
          {
            "name": "JiraDateFieldPayload"
          },
          {
            "name": "JiraDateTimeFieldPayload"
          },
          {
            "name": "JiraDeclineBoardViewsForWorkflowsPayload"
          },
          {
            "name": "JiraDeleteAllAttachmentsPayload"
          },
          {
            "name": "JiraDeleteAllIssueResourcesPayload"
          },
          {
            "name": "JiraDeleteAttachmentsPayload"
          },
          {
            "name": "JiraDeleteBoardViewStatusColumnPayload"
          },
          {
            "name": "JiraDeleteCustomBackgroundPayload"
          },
          {
            "name": "JiraDeleteCustomFieldPayload"
          },
          {
            "name": "JiraDeleteCustomFilterPayload"
          },
          {
            "name": "JiraDeleteFieldSchemePayload"
          },
          {
            "name": "JiraDeleteFormattingRulePayload"
          },
          {
            "name": "JiraDeleteIssueLinkPayload"
          },
          {
            "name": "JiraDeleteIssueSearchFormattingRulePayload"
          },
          {
            "name": "JiraDeleteIssueTypePayload"
          },
          {
            "name": "JiraDeleteNavigationItemPayload"
          },
          {
            "name": "JiraDeleteOnboardingConfigPayload"
          },
          {
            "name": "JiraDeleteProjectNotificationPreferencesPayload"
          },
          {
            "name": "JiraDeleteWorklogPayload"
          },
          {
            "name": "JiraDevOpsUpdateAssociationsPayload"
          },
          {
            "name": "JiraDevOpsUpdateVulnerabilityStatusPayload"
          },
          {
            "name": "JiraDiscardUserBoardViewConfigPayload"
          },
          {
            "name": "JiraDiscardUserTimelineViewConfigPayload"
          },
          {
            "name": "JiraDisconnectTownsquareProjectPayload"
          },
          {
            "name": "JiraDismissAiAgentSessionPayload"
          },
          {
            "name": "JiraDismissBitbucketPendingAccessRequestBannerPayload"
          },
          {
            "name": "JiraDismissDevOpsIssuePanelBannerPayload"
          },
          {
            "name": "JiraDismissForYouRecommendedActionPayload"
          },
          {
            "name": "JiraDismissInContextConfigPromptPayload"
          },
          {
            "name": "JiraDismissProjectGuestUserFlagPayload"
          },
          {
            "name": "JiraEditCustomFieldPayload"
          },
          {
            "name": "JiraEnablePlanFeaturePayloadGraphQL"
          },
          {
            "name": "JiraFieldSchemePayload"
          },
          {
            "name": "JiraFieldSetPreferencesUpdatePayload"
          },
          {
            "name": "JiraFieldSetsViewPayload"
          },
          {
            "name": "JiraFieldToFieldSchemeAssociationsPayload"
          },
          {
            "name": "JiraFieldWorkTypeConfigurationPayload"
          },
          {
            "name": "JiraFilterSearchModeMutationPayload"
          },
          {
            "name": "JiraForgeObjectFieldPayload"
          },
          {
            "name": "JiraForgeUpdatePanelPayload"
          },
          {
            "name": "JiraGlobalPermissionAddGroupGrantPayload"
          },
          {
            "name": "JiraGlobalPermissionDeleteGroupGrantPayload"
          },
          {
            "name": "JiraGlobalPermissionSetUserGroupsPayload"
          },
          {
            "name": "JiraInitializeProjectNotificationPreferencesPayload"
          },
          {
            "name": "JiraInlineIssueCreatePayload"
          },
          {
            "name": "JiraInlineIssuesCreatePayload"
          },
          {
            "name": "JiraIssueArchiveAsyncPayload"
          },
          {
            "name": "JiraIssueArchivePayload"
          },
          {
            "name": "JiraIssueCreatePayload"
          },
          {
            "name": "JiraIssueExportTaskCancellationResult"
          },
          {
            "name": "JiraIssueNavigatorJQLHistoryDeletePayload"
          },
          {
            "name": "JiraIssueNavigatorSearchLayoutMutationPayload"
          },
          {
            "name": "JiraIssueRemoteIssueLinkPayload"
          },
          {
            "name": "JiraIssueSearchGroupByFieldMutationPayload"
          },
          {
            "name": "JiraIssueSearchHideDonePreferenceMutationPayload"
          },
          {
            "name": "JiraIssueSearchHierarchyPreferenceMutationPayload"
          },
          {
            "name": "JiraIssueSearchViewPayload"
          },
          {
            "name": "JiraIssueTransitionResponse"
          },
          {
            "name": "JiraIssueTypeFieldPayload"
          },
          {
            "name": "JiraIssueUnarchivePayload"
          },
          {
            "name": "JiraJQLBuilderSearchModeMutationPayload"
          },
          {
            "name": "JiraJsmIssueViewAIPanelForServiceDeskEnabledMutationPayload"
          },
          {
            "name": "JiraJsmIssueViewAISummaryPanelForServiceDeskCollapsedMutationPayload"
          },
          {
            "name": "JiraLabelColorUpdatePayload"
          },
          {
            "name": "JiraLabelsFieldPayload"
          },
          {
            "name": "JiraLegacyTeamFieldPayload"
          },
          {
            "name": "JiraLinkIssueToVersionRelatedWorkPayload"
          },
          {
            "name": "JiraLinkIssuesToIncidentMutationPayload"
          },
          {
            "name": "JiraListSettingMigrationPayload"
          },
          {
            "name": "JiraMergeIssuesPayload"
          },
          {
            "name": "JiraMergeVersionPayload"
          },
          {
            "name": "JiraMoveBoardViewIssueToCellEndPayload"
          },
          {
            "name": "JiraMoveIssueToBacklogPayload"
          },
          {
            "name": "JiraMoveIssuesToFixVersionPayload"
          },
          {
            "name": "JiraMultipleGroupPickerFieldPayload"
          },
          {
            "name": "JiraMultipleSelectFieldPayload"
          },
          {
            "name": "JiraMultipleSelectUserPickerFieldPayload"
          },
          {
            "name": "JiraMultipleVersionPickerFieldPayload"
          },
          {
            "name": "JiraNaturalLanguageSearchSpotlightTourEnabledMutationPayload"
          },
          {
            "name": "JiraNumberFieldPayload"
          },
          {
            "name": "JiraOnboardingConfigPayload"
          },
          {
            "name": "JiraOptoutDevOpsIssuePanelNotConnectedPayload"
          },
          {
            "name": "JiraOrderFormattingRulePayload"
          },
          {
            "name": "JiraOrderIssueSearchFormattingRulePayload"
          },
          {
            "name": "JiraOriginalTimeEstimateFieldPayload"
          },
          {
            "name": "JiraParentFieldPayload"
          },
          {
            "name": "JiraPeopleFieldPayload"
          },
          {
            "name": "JiraPermissionSchemeAddGrantPayload"
          },
          {
            "name": "JiraPermissionSchemeRemoveGrantPayload"
          },
          {
            "name": "JiraPriorityFieldPayload"
          },
          {
            "name": "JiraProjectAccessRequestMutationPayload"
          },
          {
            "name": "JiraProjectCreateCustomBackgroundMutationPayload"
          },
          {
            "name": "JiraProjectDeleteCustomBackgroundMutationPayload"
          },
          {
            "name": "JiraProjectFieldPayload"
          },
          {
            "name": "JiraProjectListRightPanelStateMutationPayload"
          },
          {
            "name": "JiraProjectShortcutPayload"
          },
          {
            "name": "JiraProjectUpdateAvatarMutationPayload"
          },
          {
            "name": "JiraProjectUpdateBackgroundMutationPayload"
          },
          {
            "name": "JiraProjectUpdateNameMutationPayload"
          },
          {
            "name": "JiraPublishBoardViewConfigPayload"
          },
          {
            "name": "JiraPublishIssueSearchConfigPayload"
          },
          {
            "name": "JiraPublishTimelineViewConfigPayload"
          },
          {
            "name": "JiraRadioSelectFieldPayload"
          },
          {
            "name": "JiraRankNavigationItemPayload"
          },
          {
            "name": "JiraRemainingTimeEstimateFieldPayload"
          },
          {
            "name": "JiraRemoveActiveBackgroundPayload"
          },
          {
            "name": "JiraRemoveAgentFromBoardViewStatusColumnPayload"
          },
          {
            "name": "JiraRemoveCustomFieldPayload"
          },
          {
            "name": "JiraRemoveCustomFieldTranslationPayload"
          },
          {
            "name": "JiraRemoveFieldsFromFieldSchemePayload"
          },
          {
            "name": "JiraRemoveIssueFromSprintPayload"
          },
          {
            "name": "JiraRemoveIssuesFromAllFixVersionsPayload"
          },
          {
            "name": "JiraRemoveIssuesFromFixVersionPayload"
          },
          {
            "name": "JiraRemoveJiraBitbucketWorkspaceConnectionPayload"
          },
          {
            "name": "JiraRemovePostIncidentReviewLinkMutationPayload"
          },
          {
            "name": "JiraRemoveRelatedWorkFromVersionPayload"
          },
          {
            "name": "JiraRenameBoardViewStatusColumnPayload"
          },
          {
            "name": "JiraRenameNavigationItemPayload"
          },
          {
            "name": "JiraRenameProjectLevelSidebarMenuItemPayload"
          },
          {
            "name": "JiraReorderBoardViewColumnPayload"
          },
          {
            "name": "JiraResetFaviconPayload"
          },
          {
            "name": "JiraResetLogoPayload"
          },
          {
            "name": "JiraResolutionFieldPayload"
          },
          {
            "name": "JiraRestoreCustomFieldsPayload"
          },
          {
            "name": "JiraRestoreGlobalCustomFieldsPayload"
          },
          {
            "name": "JiraRichTextFieldPayload"
          },
          {
            "name": "JiraScheduleCalendarIssuePayload"
          },
          {
            "name": "JiraScheduleCalendarIssueWithScenarioPayload"
          },
          {
            "name": "JiraScheduleTimelineItemPayload"
          },
          {
            "name": "JiraSecurityLevelFieldPayload"
          },
          {
            "name": "JiraServiceManagementCreateAndAssociateWorkflowFromTemplatePayload"
          },
          {
            "name": "JiraServiceManagementCreateRequestTypeFromTemplatePayload"
          },
          {
            "name": "JiraServiceManagementCreateRequestTypeFromTemplateResult"
          },
          {
            "name": "JiraServiceManagementEntitlementFieldPayload"
          },
          {
            "name": "JiraServiceManagementRequestTypeCategoryDefaultPayload"
          },
          {
            "name": "JiraServiceManagementRequestTypeCategoryPayload"
          },
          {
            "name": "JiraServiceManagementSentimentFieldPayload"
          },
          {
            "name": "JiraSetAgentSessionIsPlanModeEnabledResponsePayload"
          },
          {
            "name": "JiraSetApplicationPropertiesPayload"
          },
          {
            "name": "JiraSetBacklogViewPayload"
          },
          {
            "name": "JiraSetBoardIssueCardCoverPayload"
          },
          {
            "name": "JiraSetBoardViewCardFieldSelectedPayload"
          },
          {
            "name": "JiraSetBoardViewCardOptionStatePayload"
          },
          {
            "name": "JiraSetBoardViewColumnStatePayload"
          },
          {
            "name": "JiraSetBoardViewColumnsOrderPayload"
          },
          {
            "name": "JiraSetBoardViewCompletedIssueSearchCutOffPayload"
          },
          {
            "name": "JiraSetBoardViewFilterPayload"
          },
          {
            "name": "JiraSetBoardViewGroupByPayload"
          },
          {
            "name": "JiraSetBoardViewStatusColumnIssueCountLimitPayload"
          },
          {
            "name": "JiraSetBoardViewStatusColumnMappingPayload"
          },
          {
            "name": "JiraSetBoardViewSwimlaneStatePayload"
          },
          {
            "name": "JiraSetBoardViewWorkflowSelectedPayload"
          },
          {
            "name": "JiraSetCapacityMostRecentSubRoutePayload"
          },
          {
            "name": "JiraSetCustomFieldTranslationPayload"
          },
          {
            "name": "JiraSetDefaultNavigationItemPayload"
          },
          {
            "name": "JiraSetFaviconPayload"
          },
          {
            "name": "JiraSetFieldAssociationWithIssueTypesPayload"
          },
          {
            "name": "JiraSetFieldSetsPreferencesPayload"
          },
          {
            "name": "JiraSetFormulaFieldExpressionConfigPayload"
          },
          {
            "name": "JiraSetIgnoreAgentContextPayload"
          },
          {
            "name": "JiraSetIsAgentAssignableResponsePayload"
          },
          {
            "name": "JiraSetIsFavouritePayload"
          },
          {
            "name": "JiraSetIssueSearchAggregationConfigPayload"
          },
          {
            "name": "JiraSetIssueSearchGroupByPayload"
          },
          {
            "name": "JiraSetIssueSearchHideDoneItemsPayload"
          },
          {
            "name": "JiraSetIssueSearchHideWarningsPayload"
          },
          {
            "name": "JiraSetIssueSearchHierarchyEnabledPayload"
          },
          {
            "name": "JiraSetIssueSearchJqlPayload"
          },
          {
            "name": "JiraSetIssueSearchViewLayoutPayload"
          },
          {
            "name": "JiraSetJswBoardViewSettingsPayload"
          },
          {
            "name": "JiraSetLogoPayload"
          },
          {
            "name": "JiraSetMostRecentlyViewedBoardPayload"
          },
          {
            "name": "JiraSetMyFilterFieldsPayload"
          },
          {
            "name": "JiraSetProjectPolicyAssociatedProjectsPayload"
          },
          {
            "name": "JiraSetProjectSelectedDeploymentAppsPropertyPayload"
          },
          {
            "name": "JiraSetTimelineBarColorModePayload"
          },
          {
            "name": "JiraSetTimelineChildIssuePlanningModePayload"
          },
          {
            "name": "JiraSetTimelineHighlightedReleasesPayload"
          },
          {
            "name": "JiraSetTimelineSearchFiltersPayload"
          },
          {
            "name": "JiraSetTimelineViewFieldSetsPayload"
          },
          {
            "name": "JiraSetTimelineViewHideDependenciesPayload"
          },
          {
            "name": "JiraSetTimelineViewHideReleasesPayload"
          },
          {
            "name": "JiraSetTimelineViewHideWarningsPayload"
          },
          {
            "name": "JiraSetTimelineViewRangeModePayload"
          },
          {
            "name": "JiraSetViewFilterPayload"
          },
          {
            "name": "JiraSetViewGroupByPayload"
          },
          {
            "name": "JiraShowUnscheduledIssuesCalendarMutationPayload"
          },
          {
            "name": "JiraSingleGroupPickerFieldPayload"
          },
          {
            "name": "JiraSingleLineTextFieldPayload"
          },
          {
            "name": "JiraSingleSelectFieldPayload"
          },
          {
            "name": "JiraSingleSelectUserPickerFieldPayload"
          },
          {
            "name": "JiraSingleVersionPickerFieldPayload"
          },
          {
            "name": "JiraSpreadsheetViewPayload"
          },
          {
            "name": "JiraSprintFieldPayload"
          },
          {
            "name": "JiraSprintMutationPayload"
          },
          {
            "name": "JiraStartAiAgentSessionPayload"
          },
          {
            "name": "JiraStatusFieldPayload"
          },
          {
            "name": "JiraStoryPointEstimateFieldPayload"
          },
          {
            "name": "JiraSubmitBulkOperationPayload"
          },
          {
            "name": "JiraTeamFieldPayload"
          },
          {
            "name": "JiraTimeTrackingFieldPayload"
          },
          {
            "name": "JiraTimelineIssueLinkOperationPayload"
          },
          {
            "name": "JiraTrackRecentIssuePayload"
          },
          {
            "name": "JiraTrackRecentProjectPayload"
          },
          {
            "name": "JiraTrashCustomFieldsPayload"
          },
          {
            "name": "JiraTrashGlobalCustomFieldsPayload"
          },
          {
            "name": "JiraUnlinkIssuesFromIncidentMutationPayload"
          },
          {
            "name": "JiraUnsplashAttributionPayload"
          },
          {
            "name": "JiraUpdateActiveBackgroundPayload"
          },
          {
            "name": "JiraUpdateBoardViewStatusColumnAgentPayload"
          },
          {
            "name": "JiraUpdateCalendarViewConfigPayload"
          },
          {
            "name": "JiraUpdateConfluenceRemoteIssueLinksFieldPayload"
          },
          {
            "name": "JiraUpdateCustomBackgroundPayload"
          },
          {
            "name": "JiraUpdateCustomFieldDefaultContextOptionsPayload"
          },
          {
            "name": "JiraUpdateCustomFieldPayload"
          },
          {
            "name": "JiraUpdateCustomFieldsPayload"
          },
          {
            "name": "JiraUpdateCustomFilterJqlPayload"
          },
          {
            "name": "JiraUpdateCustomFilterPayload"
          },
          {
            "name": "JiraUpdateFlagFieldPayload"
          },
          {
            "name": "JiraUpdateFormattingRulePayload"
          },
          {
            "name": "JiraUpdateGlobalCustomFieldPayload"
          },
          {
            "name": "JiraUpdateGlobalPreferencesPayload"
          },
          {
            "name": "JiraUpdateIssueLinkRelationshipTypeFieldPayload"
          },
          {
            "name": "JiraUpdateIssueSearchFormattingRulePayload"
          },
          {
            "name": "JiraUpdateJourneyConfigurationPayload"
          },
          {
            "name": "JiraUpdateNotificationOptionsPayload"
          },
          {
            "name": "JiraUpdateOverviewPlanMigrationChangeboardingPayload"
          },
          {
            "name": "JiraUpdateParentAndRankPayload"
          },
          {
            "name": "JiraUpdateProjectAdminAttributePayload"
          },
          {
            "name": "JiraUpdateProjectNotificationPreferencesPayload"
          },
          {
            "name": "JiraUpdateReleaseNotesConfigurationPayload"
          },
          {
            "name": "JiraUpdateTeamsFieldFilterPayload"
          },
          {
            "name": "JiraUpdateVersionPayload"
          },
          {
            "name": "JiraUpdateVersionRelatedWorkGenericLinkPayload"
          },
          {
            "name": "JiraUpdateVersionWarningConfigPayload"
          },
          {
            "name": "JiraUpdateViewConfigPayload"
          },
          {
            "name": "JiraUpsertIssueTypePayload"
          },
          {
            "name": "JiraUrlFieldPayload"
          },
          {
            "name": "JiraUserBroadcastMessageActionPayload"
          },
          {
            "name": "JiraUserNavigationConfigurationPayload"
          },
          {
            "name": "JiraVersionAddApproverPayload"
          },
          {
            "name": "JiraVersionDeleteApproverPayload"
          },
          {
            "name": "JiraVersionDetailsCollapsedUisPayload"
          },
          {
            "name": "JiraVersionIssueTableColumnHiddenStatePayload"
          },
          {
            "name": "JiraVersionUpdateApproverDeclineReasonPayload"
          },
          {
            "name": "JiraVersionUpdateApproverDescriptionPayload"
          },
          {
            "name": "JiraVersionUpdateApproverStatusPayload"
          },
          {
            "name": "JiraVersionUpdateReleaseNotesTypePreferencePayload"
          },
          {
            "name": "JiraVotesFieldPayload"
          },
          {
            "name": "JiraWatchesFieldPayload"
          },
          {
            "name": "JiraWorkManagementAssociateFieldPayload"
          },
          {
            "name": "JiraWorkManagementBoardSettingsPayload"
          },
          {
            "name": "JiraWorkManagementCreateCustomBackgroundPayload"
          },
          {
            "name": "JiraWorkManagementCreateFieldPayload"
          },
          {
            "name": "JiraWorkManagementCreateIssuePayload"
          },
          {
            "name": "JiraWorkManagementCreateSavedViewPayload"
          },
          {
            "name": "JiraWorkManagementDeleteAttachmentPayload"
          },
          {
            "name": "JiraWorkManagementDeleteCustomBackgroundPayload"
          },
          {
            "name": "JiraWorkManagementDeleteFieldPayload"
          },
          {
            "name": "JiraWorkManagementGiraCreateOverviewPayload"
          },
          {
            "name": "JiraWorkManagementGiraDeleteOverviewPayload"
          },
          {
            "name": "JiraWorkManagementGiraUpdateOverviewPayload"
          },
          {
            "name": "JiraWorkManagementRemoveActiveBackgroundPayload"
          },
          {
            "name": "JiraWorkManagementUpdateActiveBackgroundPayload"
          },
          {
            "name": "JiraWorkManagementUpdateCustomBackgroundPayload"
          },
          {
            "name": "JiraWorkManagementUpdateFieldPayload"
          },
          {
            "name": "JiraWorklogPayload"
          },
          {
            "name": "JsmOrganizationFieldPayload"
          },
          {
            "name": "JwmCreateFilterPayload"
          },
          {
            "name": "JwmUpdateFilterPayload"
          },
          {
            "name": "RankMutationPayload"
          },
          {
            "name": "ScheduleTimelineItemPayload"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ProjectCategoryGadgetUnion",
        "possibleTypes": [
          {
            "name": "ProjectsGadgetItem"
          },
          {
            "name": "CategoriesGadgetItem"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "QueryErrorExtension",
        "possibleTypes": [
          {
            "name": "DefaultQueryErrorExtension"
          },
          {
            "name": "JiraIssueFieldUnsupportedErrorExtension"
          },
          {
            "name": "JiraIssueFieldValueValidationErrorExtension"
          },
          {
            "name": "JiraIssueSearchErrorExtension"
          },
          {
            "name": "JiraVersionConnectionResultQueryErrorExtension"
          },
          {
            "name": "JiraWorkManagementQueryErrorExtension"
          },
          {
            "name": "JqlSyntaxQueryErrorExtension"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "RemoteIssueDetailsUnion",
        "possibleTypes": [
          {
            "name": "AssociatedIssueWrapper"
          },
          {
            "name": "FailedRemoteIssue"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "RemoteJiraIssueLinkForJpdResult",
        "possibleTypes": [
          {
            "name": "RemoteJiraIssueLinkForJpdResultSuccess"
          },
          {
            "name": "RemoteJiraIssueLinkForJpdResultError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "RemoteJiraIssueLinkResult",
        "possibleTypes": [
          {
            "name": "RemoteJiraIssueLinkResultSuccess"
          },
          {
            "name": "RemoteJiraIssueLinkResultError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SectionItem",
        "possibleTypes": [
          {
            "name": "GroupLayout"
          },
          {
            "name": "TabLayout"
          },
          {
            "name": "FieldSectionItem"
          },
          {
            "name": "EcosystemSectionItem"
          },
          {
            "name": "ForgeSectionItem"
          },
          {
            "name": "PanelSectionItem"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "StatisticsParameters",
        "possibleTypes": [
          {
            "name": "IssueStatisticsParameters"
          },
          {
            "name": "PieChartParameters"
          },
          {
            "name": "WorkloadPieChartParameters"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "TimeSeriesChartAdditionalPropertiesUnion",
        "possibleTypes": [
          {
            "name": "CreatedVsResolvedProperties"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "TimeSeriesParameters",
        "possibleTypes": [
          {
            "name": "CreatedVsResolvedGadgetParameters"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "User",
        "possibleTypes": [
          {
            "name": "AtlassianAccountUser"
          }
        ]
      }
    ]
  }
}